/*eslint-disable*/
// 背景：
// 本文件为后端生成文件，感觉后端生成后传cdn，前端引入更合理，组长觉得前端管理更合理，所以写到项目了
//
// 改动方案：
// 如果添加变量，在 f.messages 里添加后即可
// 后端上线后可以通过 https://e.qq.com/ags/assets/settings.js 拿到最新的 settings.js 文件，可做对比校验
//
// 注意：
// 不要复制！不要复制！不要复制！
// 里面有对 e.qq.com 和 http://agent.tsa.oa.com 两版 settings.js 的兼容。所以不要复制
function isOa() {
  // woa.com不算oa域
  if (/\.oa\.com/.test(location.host)) {
    return true;
  }
  return false;
}

var jsRoutes = {};
(function (_root) {
  var _nS = function (c, f, b) {
    var e = c.split(f || "."), g = b || _root, d, a;
    for (d = 0, a = e.length; d < a; d++) {
      g = g[e[d]] = g[e[d]] || {}
    }
    return g
  }
  var _qS = function (items) {
    var qs = '';
    for (var i = 0; i < items.length; i++) {
      if (items[i]) qs += (qs ? '&' : '') + items[i]
    }
    ;
    return qs ? ('?' + qs) : ''
  }
  var _s = function (p, s) {
    return p + ((s === true || (s && s.secure)) ? 's' : '') + '://'
  }

  function _wA(r) {
    var url = '/ags' + r.url;
    return {
      ajax: function (c) {
        c = c || {};
        c.url = url;
        c.type = r.method;
        return jQuery.ajax(c)
      },
      method: r.method,
      type: r.method,
      url: url,
      absoluteURL: function (s) {
        return _s('http', s) + 'e.qq.com\/ags' + url
      },
      webSocketURL: function (s) {
        return _s('ws', s) + 'e.qq.com\/ags' + url
      }
    }
  }

  if(isOa()) {
    function _wA(r) {
      var url = '/ags' + r.url;
      return {
        ajax:function(c){c=c||{};c.url=url;c.type=r.method;return jQuery.ajax(c)},
        method: r.method,
        type: r.method,
        url: url,
        absoluteURL: function (s) {
          return _s('http', s) + 'agent.tsa.oa.com\/ags' + url
        },
        webSocketURL: function (s) {
          return _s('ws', s) + 'agent.tsa.oa.com\/ags' + url
        }
      }
    }
  }

  _nS('controllers.LoginController');
  _root['controllers']['LoginController']['heartbeat'] =
    function () {

      if (true) {
        return _wA({method: "HEAD", url: "/"})
      }

    }
  ;
  _nS('controllers.LoginController');
  _root['controllers']['LoginController']['heartbeat'] =
    function () {

      if (true) {
        return _wA({method: "HEAD", url: "/"})
      }

    }
  ;
  _nS('controllers.QidianCallbackController');
  _root['controllers']['QidianCallbackController']['echo'] =
    function (signature0, timestamp1, nonce2, echostr3) {

      if (true) {
        return _wA({
          method: "GET", url: "/" + "qidian-test/message/callback" + _qS([(function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("signature", signature0), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("timestamp", timestamp1), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("nonce", nonce2), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("echostr", echostr3)])
        })
      }

    }
  ;
  _nS('controllers.QidianCallbackController');
  _root['controllers']['QidianCallbackController']['echo'] =
    function (signature0, timestamp1, nonce2, echostr3) {

      if (true) {
        return _wA({
          method: "GET", url: "/" + "qidian-test/message/callback" + _qS([(function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("signature", signature0), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("timestamp", timestamp1), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("nonce", nonce2), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("echostr", echostr3)])
        })
      }

    }
  ;
  _nS('controllers.QidianCallbackController');
  _root['controllers']['QidianCallbackController']['instruction'] =
    function (code0, state1, app_id2) {

      if (true) {
        return _wA({
          method: "GET", url: "/" + "portal/qidian-test/instruction/callback" + _qS([(function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("code", code0), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("state", state1), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("app_id", app_id2)])
        })
      }

    }
  ;
  _nS('controllers.QidianCallbackController');
  _root['controllers']['QidianCallbackController']['ticket'] =
    function (msg_signature0, timestamp1, nonce2, encrypt_type3) {

      if (true) {
        return _wA({
          method: "POST",
          url: "/" + "portal/qidian-test/ticket/callback" + _qS([(msg_signature0 == null ? null : (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("msg_signature", msg_signature0)), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("timestamp", timestamp1), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("nonce", nonce2), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("encrypt_type", encrypt_type3)])
        })
      }

    }
  ;
  _nS('controllers.QidianCallbackController');
  _root['controllers']['QidianCallbackController']['post'] =
    function (msg_signature0, timestamp1, nonce2, encrypt_type3) {

      if (true) {
        return _wA({
          method: "POST",
          url: "/" + "portal/qidian-test/message/callback" + _qS([(msg_signature0 == null ? null : (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("msg_signature", msg_signature0)), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("timestamp", timestamp1), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("nonce", nonce2), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("encrypt_type", encrypt_type3)])
        })
      }

    }
  ;
  _nS('controllers.QidianCallbackController');
  _root['controllers']['QidianCallbackController']['echo'] =
    function (signature0, timestamp1, nonce2, echostr3) {

      if (true) {
        return _wA({
          method: "GET", url: "/" + "qidian-test/message/callback" + _qS([(function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("signature", signature0), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("timestamp", timestamp1), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("nonce", nonce2), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("echostr", echostr3)])
        })
      }

    }
  ;
  _nS('controllers.QidianCallbackController');
  _root['controllers']['QidianCallbackController']['echo'] =
    function (signature0, timestamp1, nonce2, echostr3) {

      if (true) {
        return _wA({
          method: "GET", url: "/" + "qidian-test/message/callback" + _qS([(function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("signature", signature0), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("timestamp", timestamp1), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("nonce", nonce2), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("echostr", echostr3)])
        })
      }

    }
  ;
  _nS('controllers.QidianCallbackController');
  _root['controllers']['QidianCallbackController']['instruction'] =
    function (code0, state1, app_id2) {

      if (true) {
        return _wA({
          method: "GET", url: "/" + "portal/qidian-test/instruction/callback" + _qS([(function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("code", code0), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("state", state1), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("app_id", app_id2)])
        })
      }

    }
  ;
  _nS('controllers.QidianCallbackController');
  _root['controllers']['QidianCallbackController']['ticket'] =
    function (msg_signature0, timestamp1, nonce2, encrypt_type3) {

      if (true) {
        return _wA({
          method: "POST",
          url: "/" + "portal/qidian-test/ticket/callback" + _qS([(msg_signature0 == null ? null : (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("msg_signature", msg_signature0)), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("timestamp", timestamp1), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("nonce", nonce2), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("encrypt_type", encrypt_type3)])
        })
      }

    }
  ;
  _nS('controllers.QidianCallbackController');
  _root['controllers']['QidianCallbackController']['post'] =
    function (msg_signature0, timestamp1, nonce2, encrypt_type3) {

      if (true) {
        return _wA({
          method: "POST",
          url: "/" + "portal/qidian-test/message/callback" + _qS([(msg_signature0 == null ? null : (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("msg_signature", msg_signature0)), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("timestamp", timestamp1), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("nonce", nonce2), (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("encrypt_type", encrypt_type3)])
        })
      }

    }
  ;
  _nS('controllers.LoginController');
  _root['controllers']['LoginController']['heartbeat'] =
    function () {

      if (true) {
        return _wA({method: "HEAD", url: "/"})
      }

    }
  ;
  _nS('controllers.QidianCallbackController');
  _root['controllers']['QidianCallbackController']['getKey'] =
    function (signature0, key1) {
      return _wA({
        method: "GET", url: "/" + "portal/key/get" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("signature", signature0), (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("key", key1)])
      })
    }
  ;
  _nS('controllers.QidianCallbackController');
  _root['controllers']['QidianCallbackController']['setKey'] =
    function (signature0, key1, ttl2, value3) {
      return _wA({
        method: "GET", url: "/" + "portal/key/set" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("signature", signature0), (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("key", key1), (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("ttl", ttl2), (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("value", value3)])
      })
    }
  ;
  _nS('controllers.LoginController');
  _root['controllers']['LoginController']['checkFreeLoginTicket'] =
    function (freeTicket0) {
      return _wA({
        method: "GET", url: "/" + "auth/free-login/ticket" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("freeTicket", freeTicket0)])
      })
    }
  ;
  _nS('controllers.LoginController');
  _root['controllers']['LoginController']['freeLogin'] =
    function (agencyId0, userId1) {
      return _wA({
        method: "GET", url: "/" + "auth/free-login/" + encodeURIComponent((function (k, v) {
          return v
        })("agencyId", agencyId0)) + "/" + encodeURIComponent((function (k, v) {
          return v
        })("userId", userId1))
      })
    }
  ;
  _nS('controllers.LoginController');
  _root['controllers']['LoginController']['login'] =
    function () {
      return _wA({method: "POST", url: "/" + "auth/login"})
    }
  ;
  _nS('controllers.LoginController');
  _root['controllers']['LoginController']['sendCode'] =
    function () {
      return _wA({method: "POST", url: "/" + "auth/code"})
    }
  ;
  _nS('controllers.LoginController');
  _root['controllers']['LoginController']['getLoginStatus'] =
    function () {
      return _wA({method: "POST", url: "/" + "auth/status"})
    }
  ;
  _nS('controllers.LoginController');
  _root['controllers']['LoginController']['switchAgency'] =
    function (agencyId0) {
      return _wA({
        method: "POST", url: "/" + "auth/switch/" + encodeURIComponent((function (k, v) {
          return v
        })("agencyId", agencyId0))
      })
    }
  ;
  _nS('controllers.LoginController');
  _root['controllers']['LoginController']['getJwtToken'] =
    function (feature0) {
      return _wA({
        method: "POST", url: "/" + "auth/iframe/token" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("feature", feature0)])
      })
    }
  ;
  _nS('controllers.LoginController');
  _root['controllers']['LoginController']['debugLoginInfo'] =
    function (qq0, wechat1, userId2, bmId3, agencyId4, companyId5) {
      return _wA({
        method: "GET", url: "/" + "authdebug/info" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("qq", qq0), (wechat1 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("wechat", wechat1)), (userId2 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("userId", userId2)), (bmId3 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("bmId", bmId3)), (agencyId4 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId4)), (companyId5 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("companyId", companyId5))])
      })
    }
  ;
  _nS('controllers.LoginController');
  _root['controllers']['LoginController']['redirectOA'] =
    function () {

      if (true) {
        return _wA({method: "GET", url: "/" + "auth/redirectOA"})
      }

    }
  ;
  _nS('controllers.LoginController');
  _root['controllers']['LoginController']['redirectOA'] =
    function () {

      if (true) {
        return _wA({method: "GET", url: "/" + "auth/redirectOA"})
      }

    }
  ;
  _nS('controllers.LoginController');
  _root['controllers']['LoginController']['oaLoginInfo'] =
    function () {
      return _wA({method: "GET", url: "/" + "ags/auth/oaInfo"})
    }
  ;
  _nS('controllers.Fusion');
  _root['controllers']['Fusion']['embedded'] =
    function (any0) {

      if (any0 == "miss") {
        return _wA({method: "GET", url: "/" + "embedded"})
      }

      if (true) {
        return _wA({
          method: "GET", url: "/" + "embedded/" + (function (k, v) {
            return v
          })("any", any0)
        })
      }

    }
  ;
  _nS('controllers.Fusion');
  _root['controllers']['Fusion']['embedded'] =
    function (any0) {

      if (any0 == "miss") {
        return _wA({method: "GET", url: "/" + "embedded"})
      }

      if (true) {
        return _wA({
          method: "GET", url: "/" + "embedded/" + (function (k, v) {
            return v
          })("any", any0)
        })
      }

    }
  ;
  _nS('controllers.UtilityController');
  _root['controllers']['UtilityController']['getAreaList'] =
    function () {
      return _wA({method: "GET", url: "/" + "area"})
    }
  ;
  _nS('controllers.UtilityController');
  _root['controllers']['UtilityController']['getIndustryList'] =
    function () {
      return _wA({method: "GET", url: "/" + "industry"})
    }
  ;
  _nS('controllers.UtilityController');
  _root['controllers']['UtilityController']['getPromotedObjectList'] =
    function () {
      return _wA({method: "GET", url: "/" + "promoted-object"})
    }
  ;
  _nS('controllers.UtilityController');
  _root['controllers']['UtilityController']['getSourceTypeList'] =
    function () {
      return _wA({method: "GET", url: "/" + "source-type"})
    }
  ;
  _nS('controllers.UtilityController');
  _root['controllers']['UtilityController']['getSourceTypeTag'] =
    function () {
      return _wA({method: "GET", url: "/" + "source-type-tag"})
    }
  ;
  _nS('controllers.UtilityController');
  _root['controllers']['UtilityController']['getOrderingProductList'] =
    function () {
      return _wA({method: "GET", url: "/" + "ordering-product"})
    }
  ;
  _nS('controllers.UtilityController');
  _root['controllers']['UtilityController']['getPrivilegeList'] =
    function () {
      return _wA({method: "GET", url: "/" + "privileges"})
    }
  ;
  _nS('controllers.UtilityControllerV2');
  _root['controllers']['UtilityControllerV2']['getAreaList'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/area"})
    }
  ;
  _nS('controllers.UtilityControllerV2');
  _root['controllers']['UtilityControllerV2']['getIndustryList'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/industry"})
    }
  ;
  _nS('controllers.UtilityControllerV2');
  _root['controllers']['UtilityControllerV2']['getPromotedObjectList'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/promoted-object"})
    }
  ;
  _nS('controllers.UtilityControllerV2');
  _root['controllers']['UtilityControllerV2']['getSourceTypeList'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/source-type"})
    }
  ;
  _nS('controllers.UtilityControllerV2');
  _root['controllers']['UtilityControllerV2']['getSourceTypeTag'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/source-type-tag"})
    }
  ;
  _nS('controllers.UtilityControllerV2');
  _root['controllers']['UtilityControllerV2']['getOrderingProductList'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/ordering-product"})
    }
  ;
  _nS('controllers.UtilityControllerV2');
  _root['controllers']['UtilityControllerV2']['getPrivilegeList'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/privileges"})
    }
  ;
  _nS('controllers.UtilityControllerV2');
  _root['controllers']['UtilityControllerV2']['getDialInTagObjectList'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/dail-tag"})
    }
  ;
  _nS('controllers.UtilityControllerV2');
  _root['controllers']['UtilityControllerV2']['getPotentialSeasonObjectList'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/potential-season-type"})
    }
  ;
  _nS('controllers.UserController');
  _root['controllers']['UserController']['getUser'] =
    function (userId0) {
      return _wA({
        method: "GET", url: "/" + "user/" + encodeURIComponent((function (k, v) {
          return v
        })("userId", userId0))
      })
    }
  ;
  _nS('controllers.UserController');
  _root['controllers']['UserController']['getUserByAgencyId'] =
    function (agencyId0, userId1) {
      return _wA({
        method: "GET", url: "/" + "user/" + encodeURIComponent((function (k, v) {
          return v
        })("agencyId", agencyId0)) + "/" + encodeURIComponent((function (k, v) {
          return v
        })("userId", userId1))
      })
    }
  ;
  _nS('controllers.UserController');
  _root['controllers']['UserController']['getToken'] =
    function () {
      return _wA({method: "POST", url: "/" + "token/get-token"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['getAgencyList'] =
    function () {
      return _wA({method: "GET", url: "/" + "agency"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['getAgencyList2'] =
    function () {
      return _wA({method: "GET", url: "/" + "agency/test"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['getAgencyIdList'] =
    function (agencyId0) {
      return _wA({
        method: "GET", url: "/" + "agency/list" + _qS([(agencyId0 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId0))])
      })
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['getBmList'] =
    function () {
      return _wA({method: "GET", url: "/" + "agency/bms"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['getAgencyCompany'] =
    function (agencyId0, businessId1, companyId2) {
      return _wA({
        method: "GET", url: "/" + "agency/company" + _qS([(agencyId0 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId0)), (businessId1 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("businessId", businessId1)), (companyId2 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("companyId", companyId2))])
      })
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['getAgencyCompanyAPI'] =
    function (agencyId0, businessId1) {
      return _wA({
        method: "GET", url: "/" + "agency/api/company" + _qS([(agencyId0 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId0)), (businessId1 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("businessId", businessId1))])
      })
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['getAgencyCompanyInfoAPI'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/api/companyInfo"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['enhanceAgency'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/enhance"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['transferAgency'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/transfer"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['saveAgencyCompany'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/company/store"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['resetAgencyCompany'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/company/reset"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['getAgencyAccountList'] =
    function (platform0) {
      return _wA({
        method: "GET", url: "/" + "agency/get-agency-accounts" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("platform", platform0)])
      })
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['getManagedAgencyList'] =
    function () {
      return _wA({method: "GET", url: "/" + "agency/managed"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['searchSubAdvertiserList'] =
    function (agencyId0, keyword1, spid2) {
      return _wA({
        method: "GET", url: "/" + "agency/sub-advertisers/" + encodeURIComponent((function (k, v) {
          return v
        })("agencyId", agencyId0)) + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("keyword", keyword1), (spid2 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("spid", spid2))])
      })
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['getAgency'] =
    function (agencyId0, needAdditionalInfo1) {
      return _wA({
        method: "GET", url: "/" + "agency/" + encodeURIComponent((function (k, v) {
          return v
        })("agencyId", agencyId0)) + _qS([(needAdditionalInfo1 == null ? null : (function (k, v) {
          return k + '=' + (!!v)
        })("needAdditionalInfo", needAdditionalInfo1))])
      })
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['getCsAgency'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/get-cs-agency"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['checkAgency'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/check"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['bindAgency'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/bind"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['updateAgency'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/update"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['updateAgencyStatus'] =
    function (agencyId0, status1) {
      return _wA({
        method: "POST", url: "/" + "agency/update/status" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId0), (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("status", status1)])
      })
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['updateAgencyLeadTag'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/lead-tag/update"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['getSeatUseDetails'] =
    function (callCenterId0) {
      return _wA({
        method: "GET", url: "/" + "agency/getSeatUseDetails/" + encodeURIComponent((function (k, v) {
          return v
        })("callCenterId", callCenterId0))
      })
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['createRoles'] =
    function (callCenterId0) {
      return _wA({
        method: "GET", url: "/" + "agency/createRoles/" + encodeURIComponent((function (k, v) {
          return v
        })("callCenterId", callCenterId0))
      })
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['listRoles'] =
    function (callCenterId0) {
      return _wA({
        method: "GET", url: "/" + "agency/listRoles/" + encodeURIComponent((function (k, v) {
          return v
        })("callCenterId", callCenterId0))
      })
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['canGetPolicyNewAdvertiser'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/can-get-new-advertiser"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['getPolicyNewAdvertiser'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/get-new-advertiser"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['licenceAreaSave'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/licence-area/save"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['findGroupLicenceArea'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/group-licence-area"})
    }
  ;
  _nS('controllers.AgencyController');
  _root['controllers']['AgencyController']['findAgencyPolicyGroup'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/policy/group"})
    }
  ;
  _nS('controllers.ChannelManagerController');
  _root['controllers']['ChannelManagerController']['list'] =
    function () {
      return _wA({method: "POST", url: "/" + "channle-manager"})
    }
  ;
  _nS('controllers.ChannelManagerController');
  _root['controllers']['ChannelManagerController']['update'] =
    function () {
      return _wA({method: "POST", url: "/" + "channle-manager/update"})
    }
  ;
  _nS('controllers.ChannelManagerController');
  _root['controllers']['ChannelManagerController']['get'] =
    function (oaAccount0) {
      return _wA({
        method: "GET", url: "/" + "channle-manager/" + encodeURIComponent((function (k, v) {
          return v
        })("oaAccount", oaAccount0))
      })
    }
  ;
  _nS('controllers.PreferenceController');
  _root['controllers']['PreferenceController']['getAgencyPreference'] =
    function (agencyId0) {
      return _wA({
        method: "GET", url: "/" + "preference/agency/" + encodeURIComponent((function (k, v) {
          return v
        })("agencyId", agencyId0))
      })
    }
  ;
  _nS('controllers.PreferenceController');
  _root['controllers']['PreferenceController']['editAgencyPreference'] =
    function () {
      return _wA({method: "POST", url: "/" + "preference/agency/edit"})
    }
  ;
  _nS('controllers.PreferenceSaleOwnedController');
  _root['controllers']['PreferenceSaleOwnedController']['getSales'] =
    function () {
      return _wA({method: "POST", url: "/" + "salePreference/agencySale/getSales"})
    }
  ;
  _nS('controllers.PreferenceSaleOwnedController');
  _root['controllers']['PreferenceSaleOwnedController']['salesDel'] =
    function (saleId0) {
      return _wA({
        method: "POST",
        url: "/" + "salePreference/agencySale/salesDel/" + encodeURIComponent((function (k, v) {
          return v
        })("saleId", saleId0))
      })
    }
  ;
  _nS('controllers.PreferenceSaleOwnedController');
  _root['controllers']['PreferenceSaleOwnedController']['salesAdd'] =
    function () {
      return _wA({method: "POST", url: "/" + "salePreference/agencySale/salesAdd"})
    }
  ;
  _nS('controllers.PreferenceSaleOwnedController');
  _root['controllers']['PreferenceSaleOwnedController']['salesEdit'] =
    function () {
      return _wA({method: "POST", url: "/" + "salePreference/agencySale/salesEdit"})
    }
  ;
  _nS('controllers.EmployeePreferenceController');
  _root['controllers']['EmployeePreferenceController']['getLeadCustomizedViewFields'] =
    function (employeeId0) {
      return _wA({
        method: "GET", url: "/" + "preference/employee/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0)) + "/lead-customized-field"
      })
    }
  ;
  _nS('controllers.EmployeePreferenceController');
  _root['controllers']['EmployeePreferenceController']['getPotentialCustomizedViewFields'] =
    function (employeeId0) {
      return _wA({
        method: "GET", url: "/" + "preference/employee/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0)) + "/potential-customized-field"
      })
    }
  ;
  _nS('controllers.EmployeePreferenceController');
  _root['controllers']['EmployeePreferenceController']['getOrderCustomizedViewFields'] =
    function (employeeId0) {
      return _wA({
        method: "GET", url: "/" + "preference/employee/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0)) + "/order-customized-field"
      })
    }
  ;
  _nS('controllers.EmployeePreferenceController');
  _root['controllers']['EmployeePreferenceController']['getConversionCustomizedViewFields'] =
    function (employeeId0) {
      return _wA({
        method: "GET", url: "/" + "preference/employee/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0)) + "/conversion-customized-field"
      })
    }
  ;
  _nS('controllers.EmployeePreferenceController');
  _root['controllers']['EmployeePreferenceController']['getConversionRateCustomizedViewFields'] =
    function (employeeId0) {
      return _wA({
        method: "GET", url: "/" + "preference/employee/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0)) + "/conversion-rate-customized-field"
      })
    }
  ;
  _nS('controllers.EmployeePreferenceController');
  _root['controllers']['EmployeePreferenceController']['getEfficiencyReportCustomizedViewFields'] =
    function (employeeId0) {
      return _wA({
        method: "GET", url: "/" + "preference/employee/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0)) + "/efficiency-customized-field"
      })
    }
  ;
  _nS('controllers.EmployeePreferenceController');
  _root['controllers']['EmployeePreferenceController']['saveLeadCustomizedViewFields'] =
    function (employeeId0) {
      return _wA({
        method: "POST", url: "/" + "preference/employee/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0)) + "/lead-customized-field"
      })
    }
  ;
  _nS('controllers.EmployeePreferenceController');
  _root['controllers']['EmployeePreferenceController']['savePotentialCustomizedViewFields'] =
    function (employeeId0) {
      return _wA({
        method: "POST", url: "/" + "preference/employee/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0)) + "/potential-customized-field"
      })
    }
  ;
  _nS('controllers.EmployeePreferenceController');
  _root['controllers']['EmployeePreferenceController']['saveOrderCustomizedViewFields'] =
    function (employeeId0) {
      return _wA({
        method: "POST", url: "/" + "preference/employee/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0)) + "/order-customized-field"
      })
    }
  ;
  _nS('controllers.EmployeePreferenceController');
  _root['controllers']['EmployeePreferenceController']['saveConversionReportCustomizedViewFields'] =
    function (employeeId0) {
      return _wA({
        method: "POST", url: "/" + "preference/employee/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0)) + "/conversion-customized-field"
      })
    }
  ;
  _nS('controllers.EmployeePreferenceController');
  _root['controllers']['EmployeePreferenceController']['saveConversionRateReportCustomizedViewFields'] =
    function (employeeId0) {
      return _wA({
        method: "POST", url: "/" + "preference/employee/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0)) + "/conversion-rate-customized-field"
      })
    }
  ;
  _nS('controllers.EmployeePreferenceController');
  _root['controllers']['EmployeePreferenceController']['saveEfficiencyReportCustomizedViewFields'] =
    function (employeeId0) {
      return _wA({
        method: "POST", url: "/" + "preference/employee/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0)) + "/efficiency-customized-field"
      })
    }
  ;
  _nS('controllers.OrganizationController');
  _root['controllers']['OrganizationController']['getOrganizationTree'] =
    function () {
      return _wA({method: "GET", url: "/" + "organization/tree"})
    }
  ;
  _nS('controllers.OrganizationController');
  _root['controllers']['OrganizationController']['getTitleList'] =
    function () {
      return _wA({method: "GET", url: "/" + "organization/titles"})
    }
  ;
  _nS('controllers.OrganizationController');
  _root['controllers']['OrganizationController']['getPositionList'] =
    function () {
      return _wA({method: "GET", url: "/" + "organization/positions"})
    }
  ;
  _nS('controllers.OrganizationControllerV2');
  _root['controllers']['OrganizationControllerV2']['getOrganizationTree'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/organization/tree"})
    }
  ;
  _nS('controllers.OrganizationControllerV2');
  _root['controllers']['OrganizationControllerV2']['getTitleList'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/organization/titles"})
    }
  ;
  _nS('controllers.OrganizationControllerV2');
  _root['controllers']['OrganizationControllerV2']['getPositionList'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/organization/positions"})
    }
  ;
  _nS('controllers.RoleController');
  _root['controllers']['RoleController']['getRoleList'] =
    function () {
      return _wA({method: "GET", url: "/" + "role"})
    }
  ;
  _nS('controllers.RoleController');
  _root['controllers']['RoleController']['getBoundRoleList'] =
    function (userId0) {
      return _wA({
        method: "GET", url: "/" + "role/" + encodeURIComponent((function (k, v) {
          return v
        })("userId", userId0)) + "/bound"
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['getEmployeeUserList'] =
    function () {
      return _wA({method: "GET", url: "/" + "employee"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['createEmployee'] =
    function (agencyId0, isAdminister1) {
      return _wA({
        method: "POST", url: "/" + "employee/create" + _qS([(agencyId0 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId0)), (isAdminister1 == null ? null : (function (k, v) {
          return k + '=' + (!!v)
        })("isAdminister", isAdminister1))])
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['getSeatRoles'] =
    function (vendor0) {
      return _wA({
        method: "GET", url: "/" + "employee/seat/roles" + _qS([(vendor0 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("vendor", vendor0))])
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['getSkillGroups'] =
    function (callCenterId0) {
      return _wA({
        method: "GET", url: "/" + "employee/seat/skill/" + encodeURIComponent((function (k, v) {
          return v
        })("callCenterId", callCenterId0))
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['releaseEmployeeSeat'] =
    function (employeeId0) {
      return _wA({
        method: "POST", url: "/" + "employee/seat/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0)) + "/release"
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['getEmployeeSeatInfo'] =
    function (employeeId0) {
      return _wA({
        method: "GET", url: "/" + "employee/seat/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0))
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['getEmployeePermission'] =
    function (employeeId0) {
      return _wA({
        method: "GET", url: "/" + "employee/permissions/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0))
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['updateEmployee'] =
    function () {
      return _wA({method: "POST", url: "/" + "employee/update"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['updateCurrentEmployeeExtensionNumber'] =
    function () {
      return _wA({method: "POST", url: "/" + "employee/update-current-employee-seat"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['updateEmployeeStatus'] =
    function (employeeId0, status1, begin2, end3) {
      return _wA({
        method: "POST", url: "/" + "employee/update/status" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("employeeId", employeeId0), (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("status", status1), (begin2 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("begin", begin2)), (end3 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("end", end3))])
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['reEntry'] =
    function (employeeId0, teamId1, begin2, end3) {
      return _wA({
        method: "POST", url: "/" + "employee/update/re-entry" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("employeeId", employeeId0), (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("teamId", teamId1), (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("begin", begin2), (end3 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("end", end3))])
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['resign'] =
    function (employeeId0, end1) {
      return _wA({
        method: "POST", url: "/" + "employee/update/resign" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("employeeId", employeeId0), (end1 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("end", end1))])
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['reEntryAPI'] =
    function () {
      return _wA({method: "POST", url: "/" + "employee/api/re-entry"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['resignAPI'] =
    function () {
      return _wA({method: "POST", url: "/" + "employee/api/resign"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['checkOwnerStat'] =
    function (employeeId0) {
      return _wA({
        method: "POST", url: "/" + "employee/update/check-resign" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("employeeId", employeeId0)])
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['getCurrentEmployeeUser'] =
    function () {
      return _wA({method: "GET", url: "/" + "employee/current"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['getEmployeeUser'] =
    function (employeeId0) {
      return _wA({
        method: "GET", url: "/" + "employee/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0))
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['getEmployeeWorkingTeams'] =
    function (employeeId0) {
      return _wA({
        method: "GET", url: "/" + "employee/working-tree/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0))
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['batchTransferOwner'] =
    function () {
      return _wA({method: "POST", url: "/" + "employee/batch-transfer-owner"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['batchTransferOwner2Api'] =
    function () {
      return _wA({method: "POST", url: "/" + "employee/api/batch-transfer-owner"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['getBatchTransferDetail'] =
    function (oldOwnerId0) {
      return _wA({
        method: "GET",
        url: "/" + "employee/get-batch-transfer-detail/" + encodeURIComponent((function (k, v) {
          return v
        })("oldOwnerId", oldOwnerId0))
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['getBatchTransferDetailForJson'] =
    function (oldOwnerId0) {
      return _wA({
        method: "GET",
        url: "/" + "employee/get-batch-transfer-detail-for-json/" + encodeURIComponent((function (k, v) {
          return v
        })("oldOwnerId", oldOwnerId0))
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['getBatchTransferDetail2Api'] =
    function () {
      return _wA({method: "POST", url: "/" + "employee/api/get-batch-transfer-detail"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['getSeatUseDetails'] =
    function () {
      return _wA({method: "POST", url: "/" + "employee/getSeatUseDetails"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['automaticallyAssignSeatNo'] =
    function (agencyId0, userId1) {
      return _wA({
        method: "POST", url: "/" + "employee/automaticallyAssignSeatNo" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId0), (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("userId", userId1)])
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['unbindWechatWork'] =
    function () {
      return _wA({method: "POST", url: "/" + "employee/wechat-work/unbind"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['bindRoles'] =
    function () {
      return _wA({method: "POST", url: "/" + "employee/roles/bind"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['getAgencyUser'] =
    function (agencyId0, userId1) {
      return _wA({
        method: "GET", url: "/" + "employeedebug/info" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId0), (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("userId", userId1)])
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['checkWindow'] =
    function () {
      return _wA({method: "POST", url: "/" + "employee/check/window"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['clickUpdate'] =
    function () {
      return _wA({method: "POST", url: "/" + "employee/click/merge"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['getEmployeeUserListForSales'] =
    function () {
      return _wA({method: "POST", url: "/" + "employee/api/list"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['storeEmployeeAPI'] =
    function () {
      return _wA({method: "POST", url: "/" + "employee/api/store"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['userTransfer'] =
    function (agencyId0, oldUserId1, currentId2) {
      return _wA({
        method: "GET", url: "/" + "employeedebug/transferowner" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId0), (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("oldUserId", oldUserId1), (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("currentId", currentId2)])
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['processSync'] =
    function (agencyId0, targetId1) {
      return _wA({
        method: "POST", url: "/" + "employee/api/processSync" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId0), (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("targetId", targetId1)])
      })
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['deleteEmployee'] =
    function () {
      return _wA({method: "POST", url: "/" + "employee/api/delete"})
    }
  ;
  _nS('controllers.EmployeeController');
  _root['controllers']['EmployeeController']['getAgencyStats'] =
    function (agencyId0) {
      return _wA({
        method: "GET", url: "/" + "employee/transfer/stats" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId0)])
      })
    }
  ;
  _nS('controllers.EmployeeControllerV2');
  _root['controllers']['EmployeeControllerV2']['getEmployeeUserList'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/employee"})
    }
  ;
  _nS('controllers.EmployeeControllerV2');
  _root['controllers']['EmployeeControllerV2']['getEmployeeWorkingTeams'] =
    function (employeeId0) {
      return _wA({
        method: "GET", url: "/" + "v2/employee/working-tree/" + encodeURIComponent((function (k, v) {
          return v
        })("employeeId", employeeId0))
      })
    }
  ;
  _nS('controllers.EmployeeControllerV2');
  _root['controllers']['EmployeeControllerV2']['getPartnerInfo'] =
    function (partnerUserId0) {
      return _wA({
        method: "GET", url: "/" + "v2/employee/partner/" + encodeURIComponent((function (k, v) {
          return v
        })("partnerUserId", partnerUserId0))
      })
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['create'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/create"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['createSelfOpen'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/create-self-open"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['update'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/update"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['updateSelfOpen'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/update-self-open"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['getIndustryCertificationsHierarchyList'] =
    function (industryId0) {

      if (true) {
        return _wA({
          method: "GET", url: "/" + "registration/certifications/" + encodeURIComponent((function (k, v) {
            return v
          })("industryId", industryId0))
        })
      }

    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['getRegistrationDetail'] =
    function (registrationTicketId0) {

      if (true) {
        return _wA({
          method: "GET", url: "/" + "registration/detail/" + encodeURIComponent((function (k, v) {
            return v
          })("registrationTicketId", registrationTicketId0))
        })
      }

    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['upload'] =
    function () {

      if (true) {
        return _wA({method: "POST", url: "/" + "registration/upload"})
      }

    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['close'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/close"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['withdraw'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/withdraw"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['getAdvertiserInfo'] =
    function (customerId0) {
      return _wA({
        method: "GET", url: "/" + "registration/advertiser/" + encodeURIComponent((function (k, v) {
          return v
        })("customerId", customerId0))
      })
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['search'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/search"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['searchUnassignedList'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/search-unassigned"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['searchUnregisteredList'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/search-my-ticket"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['assignReview'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/assign-review"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['batchAssign'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/batch-assign"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['registerReviewReject'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/register-review-reject"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['updateRegistrar'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/update-registrar"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['getRegistrationOperator'] =
    function () {
      return _wA({method: "GET", url: "/" + "registration/get-register-operators"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['getOperatorsAuthorized'] =
    function () {
      return _wA({method: "GET", url: "/" + "registration/get-operators-authorized"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['register'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/gdt/register"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['updateAdvertisingInfo'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/update-advertising-info"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['registerWechatAccount'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/wechat/register"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['cancelWechatAccount'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/wechat/cancel"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['transfer'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/transfer"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['gdtOpen'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/gdt-open"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['customerProtection'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/apply-protection"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['searchProtectionInfo'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/search-protection-info"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['transferNextHandlers'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/transfer-nextHandlers"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['adqRegister'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/adq/register"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['preCheck'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/precheck"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['getAdvertisingInfoDetail'] =
    function (registrationTicketId0) {
      return _wA({
        method: "GET", url: "/" + "registration/" + encodeURIComponent((function (k, v) {
          return v
        })("registrationTicketId", registrationTicketId0))
      })
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['getRegistrationDetail'] =
    function (registrationTicketId0) {

      if (true) {
        return _wA({
          method: "GET", url: "/" + "registration/detail/" + encodeURIComponent((function (k, v) {
            return v
          })("registrationTicketId", registrationTicketId0))
        })
      }

    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['getIndustryCertificationsHierarchyList'] =
    function (industryId0) {

      if (true) {
        return _wA({
          method: "GET", url: "/" + "registration/certifications/" + encodeURIComponent((function (k, v) {
            return v
          })("industryId", industryId0))
        })
      }

    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['upload'] =
    function () {

      if (true) {
        return _wA({method: "POST", url: "/" + "registration/upload"})
      }

    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['gdtRegistrationUpdate'] =
    function () {
      return _wA({method: "POST", url: "/" + "registration/update-gdt"})
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['getRegistrationRecordList'] =
    function (registrationTicketId0) {
      return _wA({
        method: "GET", url: "/" + "registration/record/" + encodeURIComponent((function (k, v) {
          return v
        })("registrationTicketId", registrationTicketId0))
      })
    }
  ;
  _nS('controllers.RegistrationTicketController');
  _root['controllers']['RegistrationTicketController']['getAdvertisingInfo'] =
    function () {
      return _wA({method: "GET", url: "/" + "registration/account/advertising-info"})
    }
  ;
  _nS('controllers.RegistrationTicketControllerV2');
  _root['controllers']['RegistrationTicketControllerV2']['gdtOpen'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/registration/gdt-open"})
    }
  ;
  _nS('controllers.CustomerController');
  _root['controllers']['CustomerController']['getCustomer'] =
    function (customerId0) {
      return _wA({
        method: "GET", url: "/" + "customer/" + encodeURIComponent((function (k, v) {
          return v
        })("customerId", customerId0))
      })
    }
  ;
  _nS('controllers.CustomerController');
  _root['controllers']['CustomerController']['getContactList'] =
    function (leadId0, agencyId1) {
      return _wA({
        method: "GET", url: "/" + "customer/-/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + "/contact-list" + _qS([(agencyId1 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId1))])
      })
    }
  ;
  _nS('controllers.CustomerController');
  _root['controllers']['CustomerController']['getAdditionalContactList'] =
    function (leadId0) {
      return _wA({
        method: "GET", url: "/" + "customer/-/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + "/additional-contact-list"
      })
    }
  ;
  _nS('controllers.CustomerController');
  _root['controllers']['CustomerController']['check'] =
    function () {
      return _wA({method: "POST", url: "/" + "customer/check"})
    }
  ;
  _nS('controllers.CustomerController');
  _root['controllers']['CustomerController']['checkFree'] =
    function () {
      return _wA({method: "POST", url: "/" + "customer/checkdebug"})
    }
  ;
  _nS('controllers.CustomerController');
  _root['controllers']['CustomerController']['getCustomerList'] =
    function () {
      return _wA({method: "POST", url: "/" + "customer/search"})
    }
  ;
  _nS('controllers.CustomerController');
  _root['controllers']['CustomerController']['assignCustomer'] =
    function () {
      return _wA({method: "POST", url: "/" + "customer/assign"})
    }
  ;
  _nS('controllers.CustomerController');
  _root['controllers']['CustomerController']['assignCheckAccount'] =
    function () {
      return _wA({method: "POST", url: "/" + "customer/check/account-total"})
    }
  ;
  _nS('controllers.CustomerController');
  _root['controllers']['CustomerController']['assignAccount'] =
    function () {
      return _wA({method: "POST", url: "/" + "account/assign"})
    }
  ;
  _nS('controllers.CustomerController');
  _root['controllers']['CustomerController']['searchRecord'] =
    function () {
      return _wA({method: "POST", url: "/" + "customer-record/search"})
    }
  ;
  _nS('controllers.CustomerControllerV2');
  _root['controllers']['CustomerControllerV2']['getContactList'] =
    function (leadId0, agencyId1) {
      return _wA({
        method: "GET", url: "/" + "v2/customer/contact-list" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("leadId", leadId0), (agencyId1 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId1))])
      })
    }
  ;
  _nS('controllers.CustomerControllerV2');
  _root['controllers']['CustomerControllerV2']['getAdditionalContactList'] =
    function (leadId0) {
      return _wA({
        method: "GET", url: "/" + "v2/customer/additional-contact-list" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("leadId", leadId0)])
      })
    }
  ;
  _nS('controllers.CustomerControllerV2');
  _root['controllers']['CustomerControllerV2']['getCustomer'] =
    function (customerId0) {
      return _wA({
        method: "GET", url: "/" + "v2/customer/" + encodeURIComponent((function (k, v) {
          return v
        })("customerId", customerId0))
      })
    }
  ;
  _nS('controllers.CustomerControllerV2');
  _root['controllers']['CustomerControllerV2']['check'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/customer/check"})
    }
  ;
  _nS('controllers.CustomerControllerV2');
  _root['controllers']['CustomerControllerV2']['checkFree'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/customer/checkdebug"})
    }
  ;
  _nS('controllers.CustomerControllerV2');
  _root['controllers']['CustomerControllerV2']['getCustomerList'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/customer/search"})
    }
  ;
  _nS('controllers.CustomerControllerV2');
  _root['controllers']['CustomerControllerV2']['assignCustomer'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/customer/assign"})
    }
  ;
  _nS('controllers.CustomerControllerV2');
  _root['controllers']['CustomerControllerV2']['assignCheckAccount'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/customer/check/account-total"})
    }
  ;
  _nS('controllers.CustomerControllerV2');
  _root['controllers']['CustomerControllerV2']['assignAccount'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/account/assign"})
    }
  ;
  _nS('controllers.CustomerControllerV2');
  _root['controllers']['CustomerControllerV2']['searchRecord'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/customer-record/search"})
    }
  ;
  _nS('controllers.ActivityController');
  _root['controllers']['ActivityController']['get'] =
    function () {
      return _wA({method: "GET", url: "/" + "activity/searchList"})
    }
  ;
  _nS('controllers.ActivityController');
  _root['controllers']['ActivityController']['search'] =
    function () {
      return _wA({method: "POST", url: "/" + "activity/search"})
    }
  ;
  _nS('controllers.ActivityController');
  _root['controllers']['ActivityController']['getSmsActivityInfo'] =
    function () {
      return _wA({method: "POST", url: "/" + "activity/lead/search"})
    }
  ;
  _nS('controllers.ActivityController');
  _root['controllers']['ActivityController']['submitNumber'] =
    function () {
      return _wA({method: "POST", url: "/" + "activity/number-pack/sumbit"})
    }
  ;
  _nS('controllers.ActivityController');
  _root['controllers']['ActivityController']['getTelInfo'] =
    function () {
      return _wA({method: "POST", url: "/" + "activity/api/number-pack/upload"})
    }
  ;
  _nS('controllers.ActivityController');
  _root['controllers']['ActivityController']['queryUploadResult'] =
    function (uuid0) {
      return _wA({
        method: "GET", url: "/" + "upload/api/result" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("uuid", uuid0)])
      })
    }
  ;
  _nS('controllers.ActivityControllerV2');
  _root['controllers']['ActivityControllerV2']['get'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/activity/searchList"})
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['create'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead/create"})
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['search'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead/search"})
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['basicSearch'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead/basic-search"})
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['queryImportLeadResult'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead/import-result"})
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['importLead'] =
    function () {

      if (true) {
        return _wA({method: "POST", url: "/" + "lead/import"})
      }

    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['importLead'] =
    function () {

      if (true) {
        return _wA({method: "POST", url: "/" + "lead/import"})
      }

    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['assignLeads'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead/assign"})
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['batchFall2HighSeas'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead/to-highseas"})
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['leadDistributeAgency'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead/distribute-agency"})
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['get'] =
    function (leadId0, agencyId1) {
      return _wA({
        method: "GET", url: "/" + "lead/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + _qS([(agencyId1 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId1))])
      })
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['searchLog'] =
    function () {
      return _wA({method: "GET", url: "/" + "lead-log/search"})
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['update'] =
    function (leadId0) {
      return _wA({
        method: "POST", url: "/" + "lead/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + "/update"
      })
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['updateActivityRemind'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead/update"})
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['updateRemind'] =
    function (leadId0) {
      return _wA({
        method: "POST", url: "/" + "lead/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + "/remind-update"
      })
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['turn2Potential'] =
    function (leadId0) {
      return _wA({
        method: "POST", url: "/" + "lead/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + "/to-potential"
      })
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['cleaningLead'] =
    function (leadId0) {
      return _wA({
        method: "POST", url: "/" + "lead/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + "/cleaning"
      })
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['delete'] =
    function (leadId0) {
      return _wA({
        method: "POST", url: "/" + "lead/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + "/delete"
      })
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['companyVerify'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead/companyVerify"})
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['checkSpecialCharacters'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead/checkSpecialCharacters"})
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['obtain'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead/obtain"})
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['searchLeadReasonTag'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead-reasonTag/search"})
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['debugTurn2Potential'] =
    function (agencyId0, leadId1) {
      return _wA({
        method: "GET", url: "/" + "lead/debug/distribute" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId0), (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("leadId", leadId1)])
      })
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['getLeadStatus'] =
    function (leadId0) {
      return _wA({
        method: "GET", url: "/" + "lead/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + "/status"
      })
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['create'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/create"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['search'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/search"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['basicSearch'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/basic-search"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['queryImportLeadResult'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/import-result"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['importLead'] =
    function () {

      if (true) {
        return _wA({method: "POST", url: "/" + "v2/lead/import"})
      }

    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['importLead'] =
    function () {

      if (true) {
        return _wA({method: "POST", url: "/" + "v2/lead/import"})
      }

    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['assignLeads'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/assign"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['batchFall2HighSeas'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/to-highseas"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['leadDistributeAgency'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/distribute-agency"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['get'] =
    function (leadId0, agencyId1) {
      return _wA({
        method: "GET", url: "/" + "v2/lead/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + _qS([(agencyId1 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId1))])
      })
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['searchLog'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead-log/search"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['update'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/update"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['updateActivityRemind'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/activity-update"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['updateRemind'] =
    function (leadId0) {
      return _wA({
        method: "POST", url: "/" + "v2/lead/remind-update" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("leadId", leadId0)])
      })
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['turn2Potential'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/to-potential"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['cleaningLead'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/cleaning"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['delete'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/delete"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['companyVerify'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/companyVerify"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['checkSpecialCharacters'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/checkSpecialCharacters"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['obtain'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/obtain"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['searchLeadReasonTag'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead-reasonTag/search"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['debugTurn2Potential'] =
    function (agencyId0, leadId1) {
      return _wA({
        method: "GET", url: "/" + "v2/lead/debug/distribute" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId0), (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("leadId", leadId1)])
      })
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['getLeadStatus'] =
    function (leadId0) {
      return _wA({
        method: "GET", url: "/" + "v2/lead/status" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("leadId", leadId0)])
      })
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['distributePoolSearch'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/distribute-pool/search"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['putDistributePool'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/lead/putDistributePool"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['getLeadMap'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/lead/lead-map/get"})
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['getLeadSignStatistic'] =
    function (positionType0) {
      return _wA({
        method: "GET", url: "/" + "v2/lead/sign/statistics" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("positionType", positionType0)])
      })
    }
  ;
  _nS('controllers.LeadControllerV2');
  _root['controllers']['LeadControllerV2']['getFirstPageStatistic'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/lead/sign/first-page-statistics"})
    }
  ;
  _nS('controllers.LeadLabelController');
  _root['controllers']['LeadLabelController']['addLeadLabel'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead-label/add"})
    }
  ;
  _nS('controllers.LeadLabelController');
  _root['controllers']['LeadLabelController']['findAllLeadLabels'] =
    function () {
      return _wA({method: "GET", url: "/" + "lead-label/findAll"})
    }
  ;
  _nS('controllers.LeadLabelController');
  _root['controllers']['LeadLabelController']['findAppLeadLabels2API'] =
    function () {
      return _wA({method: "GET", url: "/" + "lead-label/api/findAll"})
    }
  ;
  _nS('controllers.LeadLabelController');
  _root['controllers']['LeadLabelController']['deleteLeadLabel'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead-label/delete"})
    }
  ;
  _nS('controllers.LeadLabelController');
  _root['controllers']['LeadLabelController']['updateLeadLabel'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead-label/update"})
    }
  ;
  _nS('controllers.LeadTagController');
  _root['controllers']['LeadTagController']['getLeadTagDictionaryTree'] =
    function () {
      return _wA({method: "GET", url: "/" + "lead-tag/tree"})
    }
  ;
  _nS('controllers.RecordTemplateController');
  _root['controllers']['RecordTemplateController']['add'] =
    function () {
      return _wA({method: "POST", url: "/" + "record-template/add"})
    }
  ;
  _nS('controllers.RecordTemplateController');
  _root['controllers']['RecordTemplateController']['findByEmployeeIdAndAgencyId'] =
    function () {
      return _wA({method: "GET", url: "/" + "record-template/find"})
    }
  ;
  _nS('controllers.RecordTemplateController');
  _root['controllers']['RecordTemplateController']['delete'] =
    function () {
      return _wA({method: "POST", url: "/" + "record-template/delete"})
    }
  ;
  _nS('controllers.RecordTemplateController');
  _root['controllers']['RecordTemplateController']['update'] =
    function () {
      return _wA({method: "POST", url: "/" + "record-template/update"})
    }
  ;
  _nS('controllers.RecordTemplateControllerV2');
  _root['controllers']['RecordTemplateControllerV2']['add'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/record-template/add"})
    }
  ;
  _nS('controllers.RecordTemplateControllerV2');
  _root['controllers']['RecordTemplateControllerV2']['findByEmployeeIdAndAgencyId'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/record-template/find"})
    }
  ;
  _nS('controllers.RecordTemplateControllerV2');
  _root['controllers']['RecordTemplateControllerV2']['delete'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/record-template/delete"})
    }
  ;
  _nS('controllers.RecordTemplateControllerV2');
  _root['controllers']['RecordTemplateControllerV2']['update'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/record-template/update"})
    }
  ;
  _nS('controllers.PotentialController');
  _root['controllers']['PotentialController']['search'] =
    function () {
      return _wA({method: "POST", url: "/" + "potential/search"})
    }
  ;
  _nS('controllers.PotentialController');
  _root['controllers']['PotentialController']['searchByKeyword'] =
    function (keyword0) {
      return _wA({
        method: "GET", url: "/" + "potential/search-by-keyword" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("keyword", keyword0)])
      })
    }
  ;
  _nS('controllers.PotentialController');
  _root['controllers']['PotentialController']['assignPotentials'] =
    function () {
      return _wA({method: "POST", url: "/" + "potential/assign"})
    }
  ;
  _nS('controllers.PotentialController');
  _root['controllers']['PotentialController']['obtain'] =
    function () {
      return _wA({method: "POST", url: "/" + "potential/obtain"})
    }
  ;
  _nS('controllers.PotentialController');
  _root['controllers']['PotentialController']['get'] =
    function (leadId0, agencyId1) {
      return _wA({
        method: "GET", url: "/" + "potential/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + _qS([(agencyId1 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId1))])
      })
    }
  ;
  _nS('controllers.PotentialController');
  _root['controllers']['PotentialController']['update'] =
    function (leadId0) {
      return _wA({
        method: "POST", url: "/" + "potential/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + "/update"
      })
    }
  ;
  _nS('controllers.PotentialController');
  _root['controllers']['PotentialController']['batchFall2HighSeas'] =
    function () {
      return _wA({method: "POST", url: "/" + "potential/to-highseas"})
    }
  ;
  _nS('controllers.PotentialController');
  _root['controllers']['PotentialController']['delete'] =
    function (potentialId0) {
      return _wA({
        method: "POST", url: "/" + "potential/" + encodeURIComponent((function (k, v) {
          return v
        })("potentialId", potentialId0)) + "/delete"
      })
    }
  ;
  _nS('controllers.PotentialController');
  _root['controllers']['PotentialController']['copyPotential'] =
    function (leadId0) {
      return _wA({
        method: "POST", url: "/" + "potential/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + "/copy"
      })
    }
  ;
  _nS('controllers.PotentialController');
  _root['controllers']['PotentialController']['distributeAgencyByDistributePool'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/potential/distribute-pool/distribute-agency"})
    }
  ;
  _nS('controllers.PotentialController');
  _root['controllers']['PotentialController']['obtainFromDistributePool'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/potential/distribute-pool/obtain"})
    }
  ;
  _nS('controllers.PotentialController');
  _root['controllers']['PotentialController']['putDistributePool'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/potential/putDistributePool"})
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['create'] =
    function () {
      return _wA({method: "POST", url: "/" + "order/create"})
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['update'] =
    function (leadId0) {
      return _wA({
        method: "POST", url: "/" + "order/update" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("leadId", leadId0)])
      })
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['updateLeadInfo'] =
    function (leadId0) {
      return _wA({
        method: "POST", url: "/" + "order/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + "/update-lead"
      })
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['advertiserOperatorUpdate'] =
    function () {
      return _wA({method: "POST", url: "/" + "order/advertiser-operator-update"})
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['searchByUid'] =
    function () {
      return _wA({method: "POST", url: "/" + "order/api/sale/search-by-uid"})
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['search'] =
    function () {
      return _wA({method: "POST", url: "/" + "order/search"})
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['get'] =
    function (leadId0, agencyId1) {
      return _wA({
        method: "GET", url: "/" + "order/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + _qS([(agencyId1 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId1))])
      })
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['assignOrders'] =
    function () {
      return _wA({method: "POST", url: "/" + "order/assign"})
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['reviewOrderPayment'] =
    function () {
      return _wA({method: "POST", url: "/" + "order/review-order-payment"})
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['rejectOrderPayment'] =
    function () {
      return _wA({method: "POST", url: "/" + "order/reject-order-payment"})
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['submitOnlineReview'] =
    function () {
      return _wA({method: "POST", url: "/" + "order/review-order-effective"})
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['submitOrderOnline'] =
    function () {
      return _wA({method: "POST", url: "/" + "order/submit-order-online"})
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['delete'] =
    function (orderId0) {
      return _wA({
        method: "POST", url: "/" + "order/" + encodeURIComponent((function (k, v) {
          return v
        })("orderId", orderId0)) + "/delete"
      })
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['batchFall2HighSeas'] =
    function () {
      return _wA({method: "POST", url: "/" + "order/to-highseas"})
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['channelOrderSingleCreate'] =
    function () {
      return _wA({method: "POST", url: "/" + "channel-order/single/create"})
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['channelOrderBatchCreate'] =
    function () {
      return _wA({method: "POST", url: "/" + "channel-order/batch/create"})
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['channelOrderSearch'] =
    function () {
      return _wA({method: "POST", url: "/" + "channel-order/list"})
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['channelOrderDetail'] =
    function (leadId0) {
      return _wA({
        method: "GET", url: "/" + "channel-order/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0))
      })
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['updateChannelOrder'] =
    function (leadId0) {
      return _wA({
        method: "POST", url: "/" + "channel-order/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + "/update"
      })
    }
  ;
  _nS('controllers.OrderController');
  _root['controllers']['OrderController']['channelOrderImportResult'] =
    function () {
      return _wA({method: "POST", url: "/" + "channel-order/result"})
    }
  ;
  _nS('controllers.AccountController');
  _root['controllers']['AccountController']['search'] =
    function () {
      return _wA({method: "POST", url: "/" + "account/list"})
    }
  ;
  _nS('controllers.AccountController');
  _root['controllers']['AccountController']['findAllAccount'] =
    function () {
      return _wA({method: "POST", url: "/" + "account/findAll"})
    }
  ;
  _nS('controllers.AccountController');
  _root['controllers']['AccountController']['addCustomerRecord'] =
    function (customerId0) {
      return _wA({
        method: "POST", url: "/" + "customer-record/" + encodeURIComponent((function (k, v) {
          return v
        })("customerId", customerId0)) + "/add"
      })
    }
  ;
  _nS('controllers.AccountController');
  _root['controllers']['AccountController']['againRegistration'] =
    function (customerId0) {
      return _wA({
        method: "POST", url: "/" + "customer/" + encodeURIComponent((function (k, v) {
          return v
        })("customerId", customerId0)) + "/account/open"
      })
    }
  ;
  _nS('controllers.ActionController');
  _root['controllers']['ActionController']['getActionRecordList'] =
    function (leadId0, agencyId1) {
      return _wA({
        method: "GET", url: "/" + "action/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + _qS([(agencyId1 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId1))])
      })
    }
  ;
  _nS('controllers.ActionController');
  _root['controllers']['ActionController']['createActionRecord'] =
    function (leadId0) {
      return _wA({
        method: "POST", url: "/" + "action/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0))
      })
    }
  ;
  _nS('controllers.ActionController');
  _root['controllers']['ActionController']['updateActionRecord'] =
    function (leadId0, recordId1) {
      return _wA({
        method: "PUT", url: "/" + "action/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + "/" + encodeURIComponent((function (k, v) {
          return v
        })("recordId", recordId1))
      })
    }
  ;
  _nS('controllers.ActionControllerV2');
  _root['controllers']['ActionControllerV2']['getActionRecordList'] =
    function (leadId0, agencyId1) {
      return _wA({
        method: "GET", url: "/" + "v2/action/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + _qS([(agencyId1 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId1))])
      })
    }
  ;
  _nS('controllers.ActionControllerV2');
  _root['controllers']['ActionControllerV2']['createActionRecord'] =
    function (leadId0) {
      return _wA({
        method: "POST", url: "/" + "v2/action/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0))
      })
    }
  ;
  _nS('controllers.ActionControllerV2');
  _root['controllers']['ActionControllerV2']['updateActionRecord'] =
    function (leadId0, recordId1) {
      return _wA({
        method: "PUT", url: "/" + "v2/action/" + encodeURIComponent((function (k, v) {
          return v
        })("leadId", leadId0)) + "/" + encodeURIComponent((function (k, v) {
          return v
        })("recordId", recordId1))
      })
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadLeadExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "lead/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadPotentialExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "potential/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadOrderExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "order/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadSessionExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/call-data/detail/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadSessionStatisticsExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/call-data/daily/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadUserExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "admin/users/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadAllAgencyUserExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "sysadmin/agencies/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadAllAgencyUserCsv'] =
    function () {
      return _wA({method: "POST", url: "/" + "sysadmin/agencies/allemployees"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadAllAgencyUserCsvV2'] =
    function () {
      return _wA({method: "POST", url: "/" + "sysadmin/agencies/allemployeesV2"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadCostReport'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/cost/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadRechargeReport'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/recharge/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadPerformanceReport'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/performance/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadConversionReportExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/conversion/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadConversionRateReportExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/conversion-rate/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadEfficiencyReportExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/efficiency-evaluation/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadOutsideExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "outside/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['queryDownloadResult'] =
    function (uuid0) {
      return _wA({
        method: "GET", url: "/" + "download/result" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("uuid", uuid0)])
      })
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadChannelOrderExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "channel-order/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadBlackExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "blacklist/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadSeatReportExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "seatReport/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadRelationExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/relation/download"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadDistributePoolExcel'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/distribute-pool/download"})
    }
  ;
  _nS('controllers.DmlController');
  _root['controllers']['DmlController']['genSmbOrderDMLFile'] =
    function () {
      return _wA({method: "GET", url: "/" + "dml/order"})
    }
  ;
  _nS('controllers.DmlController');
  _root['controllers']['DmlController']['genLeadSystemSourceTypeDMLFile'] =
    function () {
      return _wA({method: "GET", url: "/" + "dml/system-source-type"})
    }
  ;
  _nS('controllers.DmlController');
  _root['controllers']['DmlController']['genMultiAccountSql'] =
    function () {
      return _wA({method: "GET", url: "/" + "dml/multi-account"})
    }
  ;
  _nS('controllers.DmlController');
  _root['controllers']['DmlController']['genSourceTypeTagDMLFile'] =
    function () {
      return _wA({method: "GET", url: "/" + "dml/source-type-tag"})
    }
  ;
  _nS('controllers.DmlController');
  _root['controllers']['DmlController']['getOrderNewFieldsDMLFile'] =
    function () {
      return _wA({method: "GET", url: "/" + "dml/order-new-fields"})
    }
  ;
  _nS('controllers.DmlController');
  _root['controllers']['DmlController']['actionRecordDataFix'] =
    function () {
      return _wA({method: "GET", url: "/" + "dml/action-record-fix"})
    }
  ;
  _nS('controllers.AttachmentController');
  _root['controllers']['AttachmentController']['upload'] =
    function () {
      return _wA({method: "POST", url: "/" + "attachment/upload"})
    }
  ;
  _nS('controllers.AttachmentController');
  _root['controllers']['AttachmentController']['get'] =
    function (agencyId0, attachmentIds1) {
      return _wA({
        method: "GET", url: "/" + "attachment/list/" + encodeURIComponent((function (k, v) {
          return v
        })("agencyId", agencyId0)) + "/" + encodeURIComponent((function (k, v) {
          return v
        })("attachmentIds", attachmentIds1))
      })
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['getJsTicket'] =
    function () {
      return _wA({method: "GET", url: "/" + "call-center/jsticket"})
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['dialOutCheck'] =
    function () {
      return _wA({method: "POST", url: "/" + "call-center/dial-out/check"})
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['dialOut'] =
    function () {
      return _wA({method: "POST", url: "/" + "call-center/dial-out"})
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['dialInCheck'] =
    function () {
      return _wA({method: "POST", url: "/" + "call-center/dial-in/check"})
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['dialInLead'] =
    function () {
      return _wA({method: "POST", url: "/" + "call-center/dial-in/lead"})
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['dialInTraceCalling'] =
    function () {
      return _wA({method: "POST", url: "/" + "call-center/dial-in/trace-calling"})
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['traceCalling'] =
    function () {
      return _wA({method: "POST", url: "/" + "call-center/trace-calling"})
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['getSeatInfo'] =
    function () {
      return _wA({method: "POST", url: "/" + "call-center/seat-info"})
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['checkCallCenterId'] =
    function (agencyId0, externalId1, vendor2) {

      if (true) {
        return _wA({
          method: "GET", url: "/" + "call-center/check/" + encodeURIComponent((function (k, v) {
            return v
          })("agencyId", agencyId0)) + "/" + encodeURIComponent((function (k, v) {
            return v
          })("externalId", externalId1)) + _qS([(vendor2 == null ? null : (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("vendor", vendor2))])
        })
      }

    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['checkCallCenterId'] =
    function (agencyId0, externalId1, vendor2) {

      if (true) {
        return _wA({
          method: "GET", url: "/" + "call-center/check/" + encodeURIComponent((function (k, v) {
            return v
          })("agencyId", agencyId0)) + "/" + encodeURIComponent((function (k, v) {
            return v
          })("externalId", externalId1)) + _qS([(vendor2 == null ? null : (function (k, v) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(v)
          })("vendor", vendor2))])
        })
      }

    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['checkSeatNo'] =
    function (agencyId0, callCenterId1, seatNo2) {
      return _wA({
        method: "GET", url: "/" + "call-center/check/seat/" + encodeURIComponent((function (k, v) {
          return v
        })("callCenterId", callCenterId1)) + "/" + encodeURIComponent((function (k, v) {
          return v
        })("seatNo", seatNo2)) + _qS([(agencyId0 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId0))])
      })
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['checkSipPrefix'] =
    function (callCenterId0, sipPrefix1) {
      return _wA({
        method: "POST", url: "/" + "call-center/check/sipPrefix/" + encodeURIComponent((function (k, v) {
          return v
        })("callCenterId", callCenterId0)) + "/" + encodeURIComponent((function (k, v) {
          return v
        })("sipPrefix", sipPrefix1))
      })
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['getBlackListRecords'] =
    function () {
      return _wA({method: "POST", url: "/" + "call-center/blacklist/search"})
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['checkBlackListRecord'] =
    function () {
      return _wA({method: "POST", url: "/" + "call-center/blacklist/check"})
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['addBlackListRecord'] =
    function () {
      return _wA({method: "POST", url: "/" + "call-center/blacklist"})
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['batchReleaseBlackListRecord'] =
    function () {
      return _wA({method: "DELETE", url: "/" + "call-center/blacklist"})
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['listDisplayNumber'] =
    function () {
      return _wA({method: "POST", url: "/" + "call-center/list-display-number"})
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['getCustomerProtectionWhiteList'] =
    function () {
      return _wA({method: "GET", url: "/" + "call-center/get-customer-protection-white-list"})
    }
  ;
  _nS('controllers.CallCenterControllerV2');
  _root['controllers']['CallCenterControllerV2']['getCustomerProtectionWhiteList'] =
    function () {
      return _wA({method: "GET", url: "/" + "v2/call-center/get-customer-protection-white-list"})
    }
  ;
  _nS('controllers.CallCenterControllerV2');
  _root['controllers']['CallCenterControllerV2']['dialInTagCalling'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/call-center/dial-in/call-tag-save"})
    }
  ;
  _nS('controllers.CallCenterControllerV2');
  _root['controllers']['CallCenterControllerV2']['get'] =
    function (phone0) {
      return _wA({
        method: "GET", url: "/" + "v2/call-center/hotlinephone-search" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("phone", phone0)])
      })
    }
  ;
  _nS('controllers.CallSessionController');
  _root['controllers']['CallSessionController']['search'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/call-data/detail"})
    }
  ;
  _nS('controllers.CallSessionController');
  _root['controllers']['CallSessionController']['statusBar'] =
    function () {
      return _wA({method: "GET", url: "/" + "report/employee/status-bar"})
    }
  ;
  _nS('controllers.CallSessionController');
  _root['controllers']['CallSessionController']['searchStatistics'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/call-data/daily"})
    }
  ;
  _nS('controllers.WorkbenchController');
  _root['controllers']['WorkbenchController']['getCompliance'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/compliance"})
    }
  ;
  _nS('controllers.WorkbenchController');
  _root['controllers']['WorkbenchController']['getCallData'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/call-data/team"})
    }
  ;
  _nS('controllers.WorkbenchController');
  _root['controllers']['WorkbenchController']['getSaleModular'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/sale-data/count"})
    }
  ;
  _nS('controllers.WorkbenchController');
  _root['controllers']['WorkbenchController']['getSaleModularPendIng'] =
    function () {

      if (true) {
        return _wA({method: "POST", url: "/" + "report/sale-data/pendIng"})
      }

    }
  ;
  _nS('controllers.WorkbenchController');
  _root['controllers']['WorkbenchController']['getSaleModularPendIng'] =
    function () {

      if (true) {
        return _wA({method: "POST", url: "/" + "report/sale-data/pendIng"})
      }

    }
  ;
  _nS('controllers.WorkbenchController');
  _root['controllers']['WorkbenchController']['getOperatePendIng'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/api/sale-pending"})
    }
  ;
  _nS('controllers.WorkbenchController');
  _root['controllers']['WorkbenchController']['getCallDataTest'] =
    function (startDate0, endDate1, teamId2) {
      return _wA({
        method: "GET", url: "/" + "report/call-data/team-test/" + encodeURIComponent((function (k, v) {
          return v
        })("startDate", startDate0)) + "/" + encodeURIComponent((function (k, v) {
          return v
        })("endDate", endDate1)) + _qS([(teamId2 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("teamId", teamId2))])
      })
    }
  ;
  _nS('controllers.CallCenterController');
  _root['controllers']['CallCenterController']['getRecord'] =
    function (agencyId0) {
      return _wA({
        method: "POST", url: "/" + "record/detail" + _qS([(agencyId0 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId0))])
      })
    }
  ;
  _nS('controllers.CallCenterControllerV2');
  _root['controllers']['CallCenterControllerV2']['getRecord'] =
    function (agencyId0) {
      return _wA({
        method: "POST", url: "/" + "v2/record/detail" + _qS([(agencyId0 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("agencyId", agencyId0))])
      })
    }
  ;
  _nS('controllers.LeadReportAnalysisController');
  _root['controllers']['LeadReportAnalysisController']['searchLeadReport'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/sale/lead-analysis"})
    }
  ;
  _nS('controllers.PotentialReportAnalysisController');
  _root['controllers']['PotentialReportAnalysisController']['searchPotentialReport'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/sale/potential-analysis"})
    }
  ;
  _nS('controllers.OrderReportAnalysisController');
  _root['controllers']['OrderReportAnalysisController']['searchOrderReport'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/sale/order-analysis"})
    }
  ;
  _nS('controllers.SeatReportAnalysisController');
  _root['controllers']['SeatReportAnalysisController']['searchSeatReport'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/sale/seat-analysis"})
    }
  ;
  _nS('controllers.PerformanceAnalysisController');
  _root['controllers']['PerformanceAnalysisController']['search'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/performance-analysis/search"})
    }
  ;
  _nS('controllers.BusinessAnalysisController');
  _root['controllers']['BusinessAnalysisController']['searchConversionReport'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/business-analysis/search-conversion"})
    }
  ;
  _nS('controllers.BusinessAnalysisController');
  _root['controllers']['BusinessAnalysisController']['searchConversionRateReport'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/business-analysis/search-conversion-rate"})
    }
  ;
  _nS('controllers.BusinessAnalysisController');
  _root['controllers']['BusinessAnalysisController']['searchEfficiencyReport'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/business-analysis/search-efficiency"})
    }
  ;
  _nS('controllers.FeatureController');
  _root['controllers']['FeatureController']['search'] =
    function () {
      return _wA({method: "POST", url: "/" + "feature/search"})
    }
  ;
  _nS('controllers.FeatureController');
  _root['controllers']['FeatureController']['save'] =
    function () {
      return _wA({method: "POST", url: "/" + "feature"})
    }
  ;
  _nS('controllers.SalesDataController');
  _root['controllers']['SalesDataController']['teamSalesData'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/sales-data/team"})
    }
  ;
  _nS('controllers.CostReportController');
  _root['controllers']['CostReportController']['search'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/cost-data/daily"})
    }
  ;
  _nS('controllers.CostReportController');
  _root['controllers']['CostReportController']['searchChargeReport'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/charge-data/daily"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['create'] =
    function () {
      return _wA({method: "POST", url: "/" + "outside/create"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['update'] =
    function (outsideTicketId0) {
      return _wA({
        method: "POST", url: "/" + "outside/update/" + encodeURIComponent((function (k, v) {
          return v
        })("outsideTicketId", outsideTicketId0))
      })
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['getOutsideTicketRecordList'] =
    function (outsideTicketId0) {
      return _wA({
        method: "GET", url: "/" + "outside/record/" + encodeURIComponent((function (k, v) {
          return v
        })("outsideTicketId", outsideTicketId0))
      })
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['count'] =
    function () {
      return _wA({method: "GET", url: "/" + "outside/ticket/count"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['get'] =
    function (outsideTicketId0) {
      return _wA({
        method: "GET", url: "/" + "outside/ticket/" + encodeURIComponent((function (k, v) {
          return v
        })("outsideTicketId", outsideTicketId0))
      })
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['getContactList'] =
    function (outsideTicketId0) {
      return _wA({
        method: "GET", url: "/" + "outside/contact/" + encodeURIComponent((function (k, v) {
          return v
        })("outsideTicketId", outsideTicketId0))
      })
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['search'] =
    function () {
      return _wA({method: "POST", url: "/" + "outside/ticket/search"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['getInsideReviewers'] =
    function () {
      return _wA({method: "GET", url: "/" + "outside/is-reviewers"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['addInsideReviewer'] =
    function () {
      return _wA({method: "POST", url: "/" + "outside/is-reviewer/add"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['deleteInsideReviewer'] =
    function () {
      return _wA({method: "POST", url: "/" + "outside/is-reviewer/delete"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['getOutsideReviewers'] =
    function () {
      return _wA({method: "GET", url: "/" + "outside/os-reviewers"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['addOutsideReviewer'] =
    function () {
      return _wA({method: "POST", url: "/" + "outside/os-reviewer/add"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['deleteOutsideReviewer'] =
    function () {
      return _wA({method: "POST", url: "/" + "outside/os-reviewer/delete"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['insideReview'] =
    function () {
      return _wA({method: "POST", url: "/" + "outside/is-review"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['outsideReview'] =
    function () {
      return _wA({method: "POST", url: "/" + "outside/os-review"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['outsideAccept'] =
    function () {
      return _wA({method: "POST", url: "/" + "outside/accept"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['outsideClose'] =
    function () {
      return _wA({method: "POST", url: "/" + "outside/close"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['outsideWithdraw'] =
    function () {
      return _wA({method: "POST", url: "/" + "outside/withdraw"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['backFill'] =
    function () {
      return _wA({method: "POST", url: "/" + "outside/back-fill"})
    }
  ;
  _nS('controllers.OutsideTicketController');
  _root['controllers']['OutsideTicketController']['transfer'] =
    function () {
      return _wA({method: "POST", url: "/" + "outside/transfer"})
    }
  ;
  _nS('controllers.QueryNeighbourhoodController');
  _root['controllers']['QueryNeighbourhoodController']['queryNeighbourhood'] =
    function () {
      return _wA({method: "GET", url: "/" + "neighbourhood/scroll_query"})
    }
  ;
  _nS('controllers.QueryNeighbourhoodController');
  _root['controllers']['QueryNeighbourhoodController']['queryNeighbourhoodByDate'] =
    function (dateStr0) {
      return _wA({
        method: "GET", url: "/" + "neighbourhood/query" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("dateStr", dateStr0)])
      })
    }
  ;
  _nS('controllers.Assets');
  _root['controllers']['Assets']['at'] =
    function (file1) {
      return _wA({
        method: "GET", url: "/" + "static/" + (function (k, v) {
          return v
        })("file", file1)
      })
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['syncEmployeeCustomer'] =
    function () {
      return _wA({method: "POST", url: "/" + "online-sales/sync-employee-customer"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['getCorpTagConfig'] =
    function () {
      return _wA({method: "POST", url: "/" + "online-sales/get-corp-tag-config"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['getTagMapping'] =
    function () {
      return _wA({method: "POST", url: "/" + "online-sales/mapping/get"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['useDefaultTagMapping'] =
    function () {
      return _wA({method: "POST", url: "/" + "online-sales/mapping/use-default"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['syncMappingData'] =
    function () {
      return _wA({method: "POST", url: "/" + "online-sales/mapping/sync-data"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['searchRelation'] =
    function () {
      return _wA({method: "POST", url: "/" + "online-sales/relation/search"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['searchLead'] =
    function () {
      return _wA({method: "POST", url: "/" + "online-sales/lead/search"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['bind'] =
    function () {
      return _wA({method: "POST", url: "/" + "online-sales/bind"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['unbind'] =
    function () {
      return _wA({method: "POST", url: "/" + "online-sales/unbind"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['listMaterial'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/online-sales/material/list"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['createMaterial'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/online-sales/material/create"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['getMaterial'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/online-sales/material/get"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['updateMaterial'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/online-sales/material/update"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['listQuote'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/online-sales/material/list-quote"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['parseUrl'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/online-sales/material/parse-url"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['upload'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/online-sales/material/file-upload"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['deleteMaterial'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/online-sales/material/delete"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['getReceiveRecord'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/online-sales/lead/receive-record"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['createSingleGroupMsg'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/online-sales/group-msg/create"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['getGroupMsg'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/online-sales/group-msg/get"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['queryCustomerCnt'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/online-sales/group-msg/query-customer-cnt"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['listGroupMsg'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/online-sales/group-msg/list"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['getExecuteResult'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/online-sales/group-msg/execute-result"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['getRelation'] =
    function () {
      return _wA({method: "POST", url: "/" + "v2/online-sales/relation/get"})
    }
  ;
  _nS('controllers.DownloadExcelController');
  _root['controllers']['DownloadExcelController']['downloadAllSeatReportExcel'] =
    function (start0) {
      return _wA({
        method: "GET", url: "/" + "agency/seatReport-downLoad/" + encodeURIComponent((function (k, v) {
          return v
        })("start", start0))
      })
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['getOperator'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency/customerId-operator"})
    }
  ;
  _nS('controllers.OnlineSalesController');
  _root['controllers']['OnlineSalesController']['convertExternalUserId'] =
    function (corpIds0) {
      return _wA({
        method: "GET", url: "/" + "online-sales/convertExternalUserId" + _qS([(function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("corpIds", corpIds0)])
      })
    }
  ;
  _nS('controllers.ActivityController');
  _root['controllers']['ActivityController']['getPhoneTest'] =
    function () {
      return _wA({method: "POST", url: "/" + "activity/phone-number/get"})
    }
  ;
  _nS('controllers.LeadController');
  _root['controllers']['LeadController']['getAmount'] =
    function () {
      return _wA({method: "POST", url: "/" + "customerId-amount/get"})
    }
  ;
  _nS('controllers.ReportBehaviorController');
  _root['controllers']['ReportBehaviorController']['privateLeadRelation'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/behaviorPrivateLead"})
    }
  ;
  _nS('controllers.ReportBehaviorController');
  _root['controllers']['ReportBehaviorController']['privatePublicRelation'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/behaviorPublicLead"})
    }
  ;
  _nS('controllers.ReportBehaviorController');
  _root['controllers']['ReportBehaviorController']['reportBehavior'] =
    function () {
      return _wA({method: "POST", url: "/" + "report/reportBury"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['importAgencyToSales'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/import/agencyToSales"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['importChannelToAgency'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/import/channelToAgency"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['importChannelToGroupLicence'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/import/channelToGroupLicence"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['agencyBatchUpdate'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/agencyPerformance/update"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['salesBatchUpdate'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/salesPerformance/update"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['getExcelImportResult'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/import/getExcelImportResult"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['salesAdd'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/sales/add"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['salesDelete'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/sales/delete"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['salesPerformanceTargetList'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/sales/performance/target/list"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['salesPerformanceTargetOverview'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/sales/performance/target/overview"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['agencyPerformanceTargetOverview'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/oa/performance/target/overview"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['agencyPerformanceTargetList'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/oa/performance/target/list"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['saleAchievementSearch'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/sale/achievement/search"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['saleAchievementOverview'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/sale/achievement/overview"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['saleAchievementRiskPrompt'] =
    function (saleId0) {
      return _wA({
        method: "GET",
        url: "/" + "agency_sales_portal/sale/achievement/risk/prompt" + _qS([(saleId0 == null ? null : (function (k, v) {
          return encodeURIComponent(k) + '=' + encodeURIComponent(v)
        })("saleId", saleId0))])
      })
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['agencyAchievementSearch'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/agency/achievement/search"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['agencyAchievementOverview'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/agency/achievement/overview"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['agencyAchievementRiskPrompt'] =
    function () {
      return _wA({method: "GET", url: "/" + "agency_sales_portal/agency/achievement/risk/prompt"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['agencyPerformanceList'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/oa/performance/list"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['agencyPerformanceRiskPrompt'] =
    function () {
      return _wA({method: "GET", url: "/" + "agency_sales_portal/oa/performance/risk/prompt"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['agencyPerformanceOverview'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/oa/performance/overview"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['downloadChannelToAgencyTemplate'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/download/performance/channelToAgencyTemplate"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['downloadAgencyToSalesTemplate'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/download/performance/agencyToSalesTemplate"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['downloadAgencyAchievementList'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/download/agency/achievement/search"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['downloadSaleAchievementList'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/download/sale/achievement/search"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['downloadOaPerformanceList'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/download/oa/performance/list"})
    }
  ;
  _nS('controllers.ValidNewCustomerManagerController');
  _root['controllers']['ValidNewCustomerManagerController']['validNewCustomerSearch'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/agency/valid-new-customer/search"})
    }
  ;
  _nS('controllers.ValidNewCustomerManagerController');
  _root['controllers']['ValidNewCustomerManagerController']['downloadvalidNewCustomerList'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/download/agency/valid-new-customer/list"})
    }
  ;
  _nS('controllers.ValidNewCustomerManagerController');
  _root['controllers']['ValidNewCustomerManagerController']['validNewCustomerOverview'] =
    function () {
      return _wA({method: "GET", url: "/" + "agency_sales_portal/agency/valid-new-customer/overview"})
    }
  ;
  _nS('controllers.ValidNewCustomerManagerController');
  _root['controllers']['ValidNewCustomerManagerController']['validNewCustomerStatistic'] =
    function () {
      return _wA({method: "GET", url: "/" + "agency_sales_portal/agency/valid-new-customer/statistic"})
    }
  ;
  _nS('controllers.CallCenterControllerV2');
  _root['controllers']['CallCenterControllerV2']['checkOperatorLine'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/call-center/check-operator-line"})
    }
  ;
  _nS('controllers.CallCenterControllerV2');
  _root['controllers']['CallCenterControllerV2']['addMatchOperatorLineRule'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/call-center/add-operator-line-rule"})
    }
  ;
  _nS('controllers.CallCenterControllerV2');
  _root['controllers']['CallCenterControllerV2']['updateMatchOperatorLineRule'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/call-center/update-operator-line-rule"})
    }
  ;
  _nS('controllers.CallCenterControllerV2');
  _root['controllers']['CallCenterControllerV2']['getMatchOperatorLineRule'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/call-center/get-operator-line-rule"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['salesProcessTargetList'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/sales/process/target/list"})
    }
  ;
  _nS('controllers.ProcessManagerController');
  _root['controllers']['ProcessManagerController']['importProcessToSales'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/import/process2Sales"})
    }
  ;
  _nS('controllers.ProcessManagerController');
  _root['controllers']['ProcessManagerController']['addProcessTarget'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/sales/process/target/add"})
    }
  ;
  _nS('controllers.ProcessManagerController');
  _root['controllers']['ProcessManagerController']['batchSaveProcessTarget'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/sales/process/target/batch_save"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['downloadSalesProcessTargetList'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/download/sales/process/target/list"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['downloadAgencyProcessList'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/download/agency/process/list"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['salesProcessList'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/sales/process/list"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['salesProcessOverview'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/sales/process/overview"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['salesProcessRiskPrompt'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/sales/process/risk/prompt"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['getWxCropSubscribeInfo'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/wxCorp/info/get"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['updateWxCropSubscribe'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/wxCorp/update"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['postRequest'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_portal/post"})
    }
  ;
  _nS('controllers.PerformanceManagerController');
  _root['controllers']['PerformanceManagerController']['saletoolPostRequest'] =
    function () {
      return _wA({method: "POST", url: "/" + "agency_sales_saletool/post"})
    }
  ;
  _nS('controllers.defaults.Auth');
  _root['controllers']['defaults']['Auth']['getLoginStatus'] =
    function () {

      if (true) {
        return _wA({method: "POST", url: "/" + "auth/status"})
      }

    }
  ;
  _nS('controllers.defaults.Auth');
  _root['controllers']['defaults']['Auth']['getLoginStatus'] =
    function () {

      if (true) {
        return _wA({method: "POST", url: "/" + "auth/status"})
      }

    }
  ;
  _nS('controllers.defaults.Auth');
  _root['controllers']['defaults']['Auth']['logout'] =
    function () {

      if (true) {
        return _wA({method: "POST", url: "/" + "auth/logout"})
      }

    }
  ;
  _nS('controllers.defaults.Auth');
  _root['controllers']['defaults']['Auth']['logout'] =
    function () {

      if (true) {
        return _wA({method: "POST", url: "/" + "auth/logout"})
      }

    }
  ;
  _root['setQuery'] = function setQuery(query) {
    _wA = query
  }
})(jsRoutes);
window.jsMessages = (function (u) {
  function f(k) {
    var m;
    if (typeof k === 'object') {
      for (var i = 0, l = k.length; i < l && f.messages[k[i]] === u; ++i) ;
      m = f.messages[k[i]] || k[0]
    } else {
      m = ((f.messages[k] !== u) ? f.messages[k] : k)
    }
    for (i = 1; i < arguments.length; i++) {
      m = m.replace('{' + (i - 1) + '}', arguments[i])
    }
    return m
  };
  f.messages = {
    "Privilege.PERM_AGENCY_LEAD_CLEAN_ALL_PENDING": "服务商 - 清洗所有待清洗的线索",
    "OrderStatus_PopOver.5.ORDER_STATUS_ONLINE": "已上线",
    "MaterialCreatorType.1.MATERIAL_CREATOR_OFFICIAL": "官方素材",
    "CustomerEmployeeTagType.1.WX_CUSTOMER_EMPLOYEE_TAG_QY": "企业标签",
    "Unauthorized.NoToken": "鉴权失败: 未在请求中找到 Token",
    "Errors.NO_PRIVILEGED_CUSTOMER_UNIBD": "未找到指定客户或无对客户的访问权限（附近推 appId: {0}）",
    "Privilege.PERM_UNKNOWN": "未知",
    "OutsideQueryType.1.OUTSIDE_QUERY_TYPE_IN_PROCESS": "流程中",
    "PotentialType_PopOver.14.POTENTIAL_SECOND_SEASON_PRODUCTS_COMPARISON": "竞品比较",
    "CallEndType.5.CALL_END_TYPE_IVR_HANG_UP": "IVR挂断",
    "ComplianceRuleDefinition.1.COMPLIANCE_RULE_TYPE_CONNECT_TIMES_VALIDATE_CALL_TIMES": "通次达标：每日接通量 ≥{0}且{1}秒以上通话≥{2}",
    "ComplianceRule.3.COMPLIANCE_RULE_TYPE_EACH": "通次或通时",
    "Privilege.PERM_AGENCY_LEAD_ASSIGN_SELF_TO_ANY": "服务商 - 分配自己的线索给任何人",
    "OutsideType.0.OUTSIDE_TYPE_UNKNOWN": "未知",
    "MaterialContentType.4.MATERIAL_CONTENT_URL": "链接",
    "ContractMethod.0.CONTRACT_METHOD_UNKNOWN": "",
    "AmsEmployeeGrade.0.EMPLOYEE_GRADE_STAFF_MEMBER": "普通职员",
    "ContactStatus.1.CONTACT_STATUS_PREFERRED": "首选",
    "OriginalSourceType.SYSTEM_SOURCE_TYPE_TENCENT_CRAWL_LEAD": "腾讯导入",
    "Education.7.PRIMARY": "小学",
    "Forbidden.NoLoginInfo": "禁止访问: 未找到登录信息",
    "Privilege.PERM_AGENCY_POTENTIAL_OBTAIN_TO_ANY": "服务商 - 从公海中申领商机给任何人",
    "Errors.AGENCY_EXISTED": "服务商已存在",
    "SystemSourceType.6.SYSTEM_SOURCE_TYPE_AGENCY_API_IMPORT": "API导入",
    "ContactStatus.0.CONTACT_STATUS_UNKNOWN": "",
    "CustomerStatus.0.": "",
    "MaterialType.1.MATERIAL_NEIGHBORHOOD": "附近推",
    "EmployeeSystemStatus.EMPLOYEE_SYSTEM_STATUS_SUSPEND": "暂停",
    "Privilege.PERM_AGENCY_LEAD_CREATE": "服务商 - 创建线索",
    "Privilege.PERM_ORGANIZATION_EMPLOYEE_TRANSFER": "服务商 - 雇员转组",
    "FeatureTag.8.FEATURE_201911_IO_MANAGEMENT": "外勤管理（2019/11）",
    "LeadsTouchTag.1.LEADS_TOUCH_TAG_LOST_CALL_OTHERS": "未接通-其他",
    "OutsideResultType.2.OUTSIDE_RESULT_TYPE_ORDER_UNSUBMITTABLE": "不可提单",
    "OrderStatus.10.ORDER_STATUS_COSTED": "账户已上线",
    "CustomerStatus.2.CUSTOMERSTATUS_PENDING": "待审核",
    "error.min.strict": "Must be strictly greater than {0}",
    "Privilege.PERM_ORGANIZATION_VIEW": "服务商 - 组织架构查看",
    "error.expected.keypathnode": "Node value expected",
    "OutsideVisitType.0.OUTSIDE_VISIT_UNKNOWN": "",
    "Privilege.PERM_ORGANIZATION_EMPLOYMENT_RECORD_EDIT": "服务商 - 编辑雇员任职记录",
    "EmployeeSearchField.4.SEAT_NO": "坐席号",
    "Privilege.PERM_AGENCY_POTENTIAL_VIEW_SELF": "服务商 - 查看自己的商机",
    "LeadReceiveRecordStatus.3.LEAD_RECEIVE_RECORD_ALREADY_RECEIVE": "因客户已经收到其他群发消息导致发送失败",
    "MaterialType.2.MATERIAL_NORMAL_FOLLOW": "常规广告",
    "PotentialType_PopOver.1.POTENTIAL_SECOND_SEASON_OPPORTUNITY_NOT_FOLLOWED_UP": "未跟进商机",
    "OrderStatus_PopOver.4.ORDER_STATUS_REVIEW": "待上线审核",
    "Privilege.PERM_AGENCY_LEAD_ASSIGN_ANY_TO_ANY": "服务商 - 分配任何人的线索给任何人",
    "LoginAccountValidPeriod.4.TWO_MONTHS": "两个月",
    "error.real.precision": "Real number value with no more than {0} digit(s) including {1} decimal(s) expected",
    "FusedOrderStatus.10.ORDER_STATUS_COSTED": "账户已上线",
    "RegistrationAdPlatformType.1.AD_PLATFORM_TYPE_GDT": "腾讯广告",
    "CallEndType.1.CALL_END_TYPE_SEAT_HANG_UP": "坐席挂断",
    "CallEndType.1.CALL_END_TYPE_UNKNOWN": "未知",
    "MaterialType.3.MATERIAL_PRODUCT_FUNC": "产品功能",
    "OutsideType.2.OUTSIDE_TYPE_II": "自行出访",
    "Privilege.PERM_AGENCY_ORDER_ASSIGN_SELF_TO_ANY": "服务商 - 分配自己的订单给任何人",
    "CleaningStatus.0.CLEANING_STATUS_UNKNOWN": "",
    "Errors.NO_AGENCY_ID": "无服务商 ID",
    "PotentialType_PopOver.3.POTENTIAL_SECOND_SEASON_CLEAR_NO_INTENTION": "明确无意向",
    "OutsideStatus.0.OUTSIDE_STATUS_UNKNOWN": "",
    "SeatPreferredPhone.0.SEAT_PREFERRED_PHONE_UNKNOWN": "未知",
    "CustomerGenderType.2.CUSTOMER_GENDER_FEMALE": "女",
    "error.expected.jsarray": "Array value expected",
    "Errors.PROTECTION_RULE_DUPLICATE_CUSTOMERID.customerId": "账户ID已存在，不可录入",
    "EmployeeSystemStatus.": "",
    "MaterialType.6.MATERIAL_AD_PUT": "广告投放",
    "LeadReceiveRecordType.1.LEAD_RECEIVE_RECORD_MATERIAL": "引用素材",
    "RegistrationStatus.1.REGISTRATION_STATUS_UNASSIGNED": "待分配",
    "OutsideStatus.6.OUTSIDE_STATUS_WITHDRAWED": "已撤回",
    "DialInFirstTagType.2.DIAL_IN_FIRST_AGENCY_SUB_CUSTOMER": "服务商子客",
    "Privilege.PERM_GLOBAL_RULE_MANAGE": "全局 - 管理全局规则",
    "ProtectionRule.7.PROTECTION_RULE_DUPLICATE_MOBILE": "手机号码相同，则不许录入",
    "TimeSpentSigningAContract.4.TIME_SPENT_SIGNING_A_CONTRACT_FOUR_WEEKS": "四周",
    "Forbidden.NoAvailableUser": "禁止访问: 未找到与登录名称 {0} 相关联的有效用户信息（QQ：{1}）",
    "PotentialStatus.1.POTENTIAL_STATUS_NEW": "待处理",
    "Errors.NO_VALID_AGENCY": "无有效的服务商",
    "error.expected.jsboolean": "Boolean value expected",
    "Errors.PROTECTION_RULE_DUPLICATE_COMPANY_NAME_AND_AD_PLATFORM_TYPE.companyNameAndAdPlatformType": "公司名称且推广目标已存在，不可录入",
    "OutsideVisitType.2.OUTSIDE_VISIT_ACTIVITY": "活动",
    "PotentialType_PopOver.19.POTENTIAL_SECOND_SEASON_PAYMENT_TO_BE_PAID": "待打款",
    "ComplianceRuleDefinition.2.COMPLIANCE_RULE_TYPE_TOTAL_DIAL_OUT_SECONDS": "通时达标：呼出总通时≥{0}秒",
    "Errors.NO_PAYLOAD": "未发送请求体",
    "GroupsMsgStatus.2.GROUP_MSG_ALREADY_SEND": "已发送",
    "Privilege.PERM_AGENCY_REPORT_COST_REPORT_VIEW_SELF_OR_GROUP": "服务商 - 查看自己/下属消耗报表",
    "Errors.NO_GRANTED_ADVERTISER": "无此广告主或该广告主未授权",
    "ReviewStatus.2.REVIEW_STATUS_REJECTED": "拒绝",
    "CustomerType.1.WX_CUSTOMER_WX": "微信客户",
    "OutsideType.1.OUTSIDE_TYPE_IO": "需外勤",
    "error.expected.jsnumberorjsstring": "String or number expected",
    "constraint.email": "Email",
    "Forbidden.InvalidRegistered": "禁止访问: 无效注册信息（登录名称 {0}，QQ：{1}）",
    "FeatureStatus.0.FEATURE_STATUS_UNKNOWN": "",
    "OriginalSourceType.SYSTEM_SOURCE_TYPE_TENCENT_BLACK_MIRROR": "腾讯导入",
    "ContactStatus.3.CONTACT_STATUS_INVALID": "无效",
    "OutsideVisitType.4.OUTSIDE_VISIT_BUSINESS_OUT": "商务外出",
    "Unauthorized.NotLoggedIn": "鉴权失败: 未登录",
    "Errors.NO_REQUIRED_PARAM": "无必填参数：{0}",
    "CustomerStatus.CUSTOMERSTATUS_FROZEN": "封停",
    "LeadSourceType.0.LEAD_SOURCE_UNKNOWN": "",
    "Errors.NO_PRIVILEGED_CUSTOMER": "未找到指定客户或无对客户的访问权限（账户 ID：{0,number,#}）",
    "Errors.NO_ADVERTISER_ID": "无有效广告主 ID",
    "Privilege.PERM_AGENCY_LEAD_CONVERT_SELF": "服务商 - 将自己的线索转为商机",
    "GroupsMsgStatus.1.GROUP_MSG_SENDING": "发送中",
    "Errors.NO_MDM_ID": "无 MDM ID，当前服务商未开通 MDM",
    "FeatureTag.15.FEATURE_202108_POTENTIAL_RELEASE_AUTOCONFIGURATION": "商机释放规则（2021/08）",
    "OrderStatus.9.ORDER_STATUS_REGISTRATION_CLOSED": "开户单关闭",
    "DialInFirstTagType.3.DIAL_IN_FIRST_SELF_SUPPORT_CUSTOMER": "自助客户",
    "Errors.NO_FORBID": "{0}",
    "Privilege.PERM_AGENCY_POTENTIAL_OBTAIN_TO_GROUP": "服务商 - 从公海中申领商机给自己/下属",
    "Errors.NO_SEAT": "未找到指定的坐席",
    "DialInFirstTagType.0.DIAL_IN_FIRST_UNKNOWN": "",
    "RegistrationStatus.3.REGISTRATION_STATUS_REGISTERING": "开户提交中",
    "OrderStatus.8.ORDER_STATUS_REGISTRATION_WITHDRAWED": "开户撤回",
    "Forbidden.InvalidTicketSession": "禁止访问：免登录的登录态异常，请清除缓存重新免登录",
    "Privilege.PERM_AGENCY_ORDER_VIEW_ALL": "服务商 - 查看所有订单",
    "RegistrationStatus.6.REGISTRATION_STATUS_WITHDRAWED": "已撤回",
    "DialInFirstTagType.7.DIAL_IN_FIRST_COMPLAINT_TAG": "投诉",
    "OutsideResultType.1.OUTSIDE_RESULT_TYPE_ORDER_SUBMITTABLE": "可提单",
    "ReviewActionType.1.REVIEW_ACTION_TYPE_PASS": "通过",
    "ProgressStatus.1.PROGRESS_STATUS_LEAD": "线索",
    "OrderStatus_PopOver.2.ORDER_STATUS_PAID": "已到款",
    "CustomerStatus.3.CUSTOMERSTATUS_DENIED": "审核不通过",
    "FeatureTag.19.FEATURE_202110_CALL_CENTER_DIAL_OUT_RELATION_LEAD": "外呼限制必须关联线索（2021/10）",
    "RegistrationStatus.8.REGISTRATION_STATUS_REGISTERED": "开户成功",
    "Education.5.SENIOR": "高中",
    "WechatAuthStatus.1.STATUS_PRE_AUTHORIZATION": "预授权",
    "Privilege.PERM_ACCESS_CONTROL_ROLE_MANAGE": "服务商 - 角色管理",
    "CustomerEmployeeRelationAddWay.1.WX_CUSTOMER_EMPLOYEE_ADD_WAY_QRCODE": "扫描二维码",
    "Education.6.JUNIOR": "初中",
    "RegistrationType.0.REGISTRATION_TYPE_UNKNOWN": "",
    "PotentialType_PopOver.8.POTENTIAL_SECOND_SEASON_LOOKING_KP": "寻找kp中",
    "Privilege.PERM_AGENCY_POTENTIAL_RELEASE_ANY": "服务商 - 释放任何人的商机到公海",
    "CustomerType.2.WX_CUSTOMER_QY_WX": "企业微信客户",
    "Errors.NO_OUTSIDE_TICKET": "未找到指定的外勤单",
    "AdPlatformType.AD_PLATFORM_TYPE_GDT": "广点通",
    "AdPlatformType.AD_PLATFORM_TYPE_MP_SOSO": "搜一搜",
    "FeatureTag.17.FEATURE_202108_LEAD_HIGHSEA_AUTOCONFIGURATION": "线索公海拨打电话规则（2021/08）",
    "Errors.NO_ORDER": "未找到指定的订单",
    "LeadsTouchTag.4.LEADS_TOUCH_TAG_LOST_CALL_INVALIDNUM": "未接通-无效号码",
    "Privilege.PERM_AGENCY_REPORT_TRAFFIC_REPORT": "服务商 - 话务报表",
    "format.uuid": "UUID",
    "error.pattern": "Must satisfy {0}",
    "Unauthorized.NoAccountId": "鉴权失败: 未在请求中找到 AccountId",
    "error.path.result.multiple": "Multiple results for the given path",
    "EmployeeSystemStatus.EMPLOYEE_SYSTEM_STATUS_NORMAL": "正常",
    "MaterialType.5.MATERIAL_AD_CREATE": "广告开户",
    "Privilege.PERM_AGENCY_POTENTIAL_EDIT_ALL": "服务商 - 编辑所有商机",
    "Errors.BAD_VISIBILITY_SCOPE": "线索{0}公私海状态{1}非法",
    "Education.4.ASSOCIATE": "专科",
    "constraint.maxLength": "Maximum length: {0}",
    "Privilege.PERM_AGENCY_LEAD_VIEW_GROUP": "服务商 - 查看下属的线索",
    "Privilege.PERM_ORGANIZATION_TEAM_EDIT": "服务商 - 编辑团队",
    "CustomerGenderType.1.CUSTOMER_GENDER_MALE": "男",
    "MixedPotentialStatus.6.POTENTIAL_STATUS_NORMAL-80": "80（购买决策）",
    "Errors.NO_MP_SPID": "没有查到对应的MP SPId的accountId",
    "CustomerStatus.CUSTOMERSTATUS_PENDING": "待审核",
    "ContactStatus.2.CONTACT_STATUS_VALID": "有效",
    "PotentialStatus.0.POTENTIAL_STATUS_UNKNOWN": "",
    "CustomerStatus.11.CUSTOMERSTATUS_UNREGISTERED": "未注册",
    "ReviewActionType.0.REVIEW_ACTION_TYPE_UNKNOWN": "",
    "ReviewStatus.1.REVIEW_STATUS_PASSED": "通过",
    "CustomerStatus.CUSTOMERSTATUS_DENIED": "审核不通过",
    "SystemSourceType.5.SYSTEM_SOURCE_TYPE_TENCENT_CRAWL_MARKETING": "市场部",
    "OriginalSourceType.SYSTEM_SOURCE_TYPE_AGENCY_CARD_IMPORT": "自建",
    "FusedOrderStatus.7.ORDER_STATUS_REGISTRATION_UNASSIGNED": "待开户分配",
    "PotentialType_PopOver.9.POTENTIAL_SECOND_SEASON_REACHED_KP": "已触达kp",
    "ProtectionRule.3.PROTECTION_RULE_DUPLICATE_COMPANY_NAME_AND_MOBILE": "公司名称且任一手机号码相同，不允许录入",
    "Privilege.PERM_AGENCY_ORDER_EDIT_GROUP": "服务商 - 编辑下属的订单",
    "Errors.EXCEED_CALL_LIMIT_NUMBER": "呼出次数超限制: {0}天内{1}次",
    "ContractMethod.3.CONTRACT_METHOD_MEETING_SALE": "会销",
    "Errors.PROTECTION_RULE_DUPLICATE_COMPANY_NAME_OR_MOBILE_OR_TELEPHONE.telephone": "座机号码[{0}]已存在，不可录入",
    "Privilege.PERM_AGENCY_LEAD_EDIT_ALL": "服务商 - 编辑所有线索",
    "FeatureTag.18.FEATURE_202109_ONLINE_SALES": "企微网销功能（2021/09）",
    "OrderStatus.6.ORDER_STATUS_NOT_ONLINE": "上线驳回",
    "Errors.NO_CONTACT": "无联系人参数",
    "error.date": "Valid date required",
    "FeatureTag.7.FEATURE_201909_COST_REPORT": "消耗报表（2019/09）",
    "OutsideStatus.2.OUTSIDE_STATUS_OS_UNREVIEW": "待分配",
    "CleaningStatus.3.CLEANING_STATUS_INVALID": "清洗不合格",
    "FeatureTag.12.FEATURE_202104_GDT_PROTECTION": "广点通客保（2021/04）",
    "Privilege.PERM_AGENCY_ORDER_ASSIGN_GROUP_TO_GROUP": "服务商 - 分配自己/下属的订单给自己/下属",
    "OriginalSourceType.SYSTEM_SOURCE_TYPE_TENCENT_DISTRIBUTE": "腾讯导入",
    "Education.1.DOCTOR": "博士",
    "Privilege.PERM_AGENCY_LEAD_VIEW_ALL": "服务商 - 查看所有线索",
    "SystemSourceType.8.SYSTEM_SOURCE_TYPE_TENCENT_BLACK_MIRROR": "玄镜导入",
    "CustomerType.0.WX_CUSTOMER_UNKNOWN": "未知",
    "constraint.required": "Required",
    "Education.3.BACHELOR": "本科",
    "GroupsMsgStatus.0.GROUP_MSG_UNKNOWN": "未知",
    "CustomerEmployeeRelationAddWay.201.WX_CUSTOMER_EMPLOYEE_ADD_WAY_MEMBER_SHARE": "内部成员共享",
    "MaterialContentType.2.MATERIAL_CONTENT_VIDEO": "视频",
    "Privilege.PERM_AGENCY_RULE_MANAGE": "服务商 - 管理本服务商的业务规则",
    "Privilege.PERM_ORGANIZATION_EMPLOYEE_ADD": "服务商 - 团队中新增雇员",
    "CustomerEmployeeRelationAddWay.6.WX_CUSTOMER_EMPLOYEE_ADD_WAY_WX_CONTACT": "微信联系人",
    "Privilege.PERM_ORGANIZATION_EMPLOYEE_QUIT": "服务商 - 离职雇员",
    "MixedPotentialStatus.7.POTENTIAL_STATUS_NORMAL-100": "100（已合作）",
    "PotentialType_PopOver.6.POTENTIAL_SECOND_SEASON_WECHAT_TO_SEND_DATA": "加微发资料",
    "Forbidden.NoLoginName": "禁止访问: 未找到登录名称",
    "Privilege.PERM_AGENCY_REPORT_RECHARGE_REPORT_VIEW_SELF_OR_GROUP": "服务商 - 查看自己/下属充值报表",
    "Errors.CONTACT_TELEPHONE_FORMAT_ERROR": "联系人座机格式有误：{0}",
    "FeatureTag.21.FEATURE_202205_POTENTIAL_HIGH_SEAS_SILENT": "商机公海-沉默线索（2022/05）",
    "error.minLength": "Minimum length is {0}",
    "EmployeeSystemStatus.2.EMPLOYEE_SYSTEM_STATUS_SUSPEND": "暂停",
    "FeatureStatus.3.FEATURE_STATUS_BLACK": "全量下线",
    "LoginAccountValidPeriod.7.INFINITY": "无限期",
    "Errors.EXCEED_CALL_LIMIT_HIGHSEA": "呼出次数超限制: {0}天内{1}次",
    "Unauthorized.InvalidJwtClaim": "鉴权失败: 无效的 JWT 声明 - {0}",
    "Errors.NO_BM_ID": "无主体 ID",
    "Forbidden.MismatchedAccountId": "禁止访问: 提供的两个 AccountId {0,number,#} 与 {1,number,#} 不匹配",
    "error.max.strict": "Must be strictly less than {0}",
    "Privilege.PERM_AGENCY_RULE_VIEW": "服务商 - 查看全局及本服务商的业务规则",
    "Unauthorized.ExpiredJwtToken": "鉴权失败: JWT Token 已过期",
    "CustomerStatus.5.CUSTOMERSTATUS_TOBE_ACCEPTED": "待接受",
    "constraint.minLength": "Minimum length: {0}",
    "Errors.BATCH_TRANSFER_SAME_OWNER": "批量转移的接收人不能和原owner相同",
    "Privilege.PERM_DEV_TEST": "开发用 - 测试",
    "LoginAccountValidPeriod.1.THREE_DAYS": "三天",
    "ProtectionRule.6.PROTECTION_RULE_DUPLICATE_COMPANY_NAME_AND_AD_PLATFORM_TYPE": "公司名称相同且推广目标一致，则不许录入",
    "FeatureTag.9.FEATURE_202001_ORDER_FUSION": "订单融合（2020/01）",
    "DialInFirstTagType.6.DIAL_IN_FIRST_NON_ADVERTISER_CONSULTING": "非广告投放咨询",
    "error.expected.jsnumber": "Number value expected",
    "MixedPotentialStatus_PopOver.4.POTENTIAL_STATUS_NORMAL-40": "客户陈述自己的现状，表明自己的需求，主动了解产品情况",
    "CustomerStatus.6.CUSTOMERSTATUS_TOBE_ACTIVATED": "待激活",
    "CustomerEmployeeRelationAddWay.8.WX_CUSTOMER_EMPLOYEE_ADD_WAY_APP_CUSTOMER_SERVICE": "安装第三方应用时自动添加的客服人员",
    "CustomerEmployeeRelationAddWay.9.WX_CUSTOMER_EMPLOYEE_ADD_WAY_SEARCH_MAIL": "搜索邮箱",
    "MixedPotentialStatus_PopOver.3.POTENTIAL_STATUS_NORMAL-20": "客户愿意加微信进一步了解",
    "ProtectionRule.2.PROTECTION_RULE_DUPLICATE_COMPANY_NAME": "公司名称相同，不允许录入",
    "ReleaseType.10.ACTION_TYPE_AUTO_RELEASE": "自动释放",
    "Unauthorized.InvalidJwtToken": "鉴权失败: 无效的 JWT Token",
    "Errors.PROTECTION_RULE_DUPLICATE_MOBILE.mobile": "手机号码[{0}]已存在，不可录入",
    "Privilege.PERM_ACCESS_CONTROL_USER_MANAGE": "服务商 - 访问控制中的用户管理",
    "Privilege.PERM_AGENCY_POTENTIAL_VIEW_HIGHSEA": "服务商 - 查看公海的商机",
    "MixedPotentialStatus.2.POTENTIAL_STATUS_NORMAL-0": "0（无法推进）",
    "SystemSourceType.0.SYSTEM_SOURCE_TYPE_UNKNOWN": "",
    "OutsideStatus.4.OUTSIDE_STATUS_VISITING": "出访中",
    "PotentialStatus.2.POTENTIAL_STATUS_NORMAL": "正常",
    "LeadReceiveRecordStatus.2.LEAD_RECEIVE_RECORD_NOT_FRIEND": "因客户不是好友导致发送失败",
    "MixedPotentialStatus_PopOver.2.POTENTIAL_STATUS_NORMAL-0": "客户基本无合作机会",
    "VisibilityScope.1.VISIBILITY_SCOPE_PRIVATE": "私海",
    "ProgressStatus.3.PROGRESS_STATUS_ORDER": "订单",
    "LeadReceiveRecordStatus.0.LEAD_RECEIVE_RECORD_NOT_SEND": "未发送",
    "Privilege.PERM_AGENCY_REPORT_COST_REPORT_VIEW_ALL": "服务商 - 查看所有消耗报表",
    "SystemSourceType.7.SYSTEM_SOURCE_TYPE_AGENCY_CARD_IMPORT": "名片引流",
    "FeatureTag.5.FEATURE_201909_OFFLINE_PUB_SECURITY": "下线 PubSecurity 权限控制相关功能（2019/09）",
    "SystemSourceType.9.SYSTEM_SOURCE_TYPE_TENCENT_DISTRIBUTE": "分发线索",
    "OperationMode.3.OPERATION_MODE_CHANNEL_OPERATING": "渠道运营",
    "Unauthorized.CheckSsoTokenFailed": "鉴权失败: 校验 SSO Token 失败 - [{0,number,#}] {1}",
    "PotentialType_PopOver.18.POTENTIAL_SECOND_SEASON_BUDGET_APPROVAL_PROGRESS": "预算审批中",
    "error.expected.date.isoformat": "Iso date value expected",
    "VisibilityScope.0.VISIBILITY_SCOPE_UNKNOWN": "",
    "OrderStatus_PopOver.10.ORDER_STATUS_COSTED": "账户已上线",
    "CustomerEmployeeStatus.2.WX_CUSTOMER_EMPLOYEE_RESIGN": "添加人已离职",
    "MixedPotentialStatus.1.POTENTIAL_STATUS_NEW-0": "待处理",
    "OperationMode.0.OPERATION_MODE_UNKNOWN": "",
    "Privilege.PERM_AGENCY_LEAD_CLEAN_SELF": "服务商 - 清洗自己的线索",
    "CustomerEmployeeStatus.0.WX_CUSTOMER_EMPLOYEE_FRIEND": "好友",
    "Errors.CONTACT_NO_NAME": "联系人无姓名",
    "CustomerStatus.CUSTOMERSTATUS_TEMPORARY_FROZEN": "冻结",
    "WechatAuthStatus.3.STATUS_REQUEST_CANCELATION": "撤销中",
    "ProgressStatus.2.PROGRESS_STATUS_POTENTIAL": "商机",
    "RegistrationStatus.7.REGISTRATION_STATUS_CLOSED": "已关闭",
    "ReleaseType.0.ACTION_TYPE_UNKNOWN": "",
    "Unauthorized.ExpiredToken": "鉴权失败: Token \"{0}\" 已过期",
    "Privilege.PERM_AGENCY_POTENTIAL_RELEASE_SELF": "服务商 - 释放自己的商机到公海",
    "CustomerEmployeeRelationAddWay.3.WX_CUSTOMER_EMPLOYEE_ADD_WAY_CARD": "名片分享",
    "Privilege.PERM_AGENCY_ORDER_PAYMENT_REVIEW": "服务商 - 订单到款审核",
    "Privilege.PERM_AGENCY_LEAD_VIEW_ALL_INVALID": "服务商 - 查看所有清理不合格的线索",
    "ReleaseType.27.ACTION_TYPE_LEAD_MANUAL_RELEASE": "手动释放",
    "CustomerEmployeeRelationAddWay.4.WX_CUSTOMER_EMPLOYEE_ADD_WAY_GROUP": "群聊",
    "LeadSourceType.1.LEAD_SOURCE_AGENCY": "自建",
    "FusedOrderStatus.8.ORDER_STATUS_REGISTRATION_WITHDRAWED": "开户撤回",
    "Privilege.PERM_ORGANIZATION_TEAM_TRANSFER": "服务商 - 迁移团队",
    "FeatureTag.20.FEATURE_202111_HIGH_SEAS_MANAGE_DISTRIBUTE_AGENCY": "公海池管理分发服务商（2021/11）",
    "MixedPotentialStatus_PopOver.1.POTENTIAL_STATUS_NEW-0": "商机未触达",
    "Errors.NO_ADVERTISER": "未找到 ID={0} 的广告主",
    "ReviewActionType.1.REVIEW_ACTION_TYPE_REJECT": "拒绝",
    "RegistrationStatus.9.REGISTRATION_STATUS_CANCELLING": "开户取消中",
    "FeatureStatus.1.FEATURE_STATUS_GRAY": "灰度上线",
    "OutsideVisitType.3.OUTSIDE_VISIT_REPORT": "汇报",
    "Forbidden.UserFreeze": "禁止访问: 用户已冻结（登录名称 {0}，QQ：{1}）",
    "FeatureTag.14.FEATURE_202108_LEAD_RELEASE_AUTOCONFIGURATION": "线索释放规则（2021/08）",
    "CustomerStatus.1.CUSTOMERSTATUS_NORMAL": "有效",
    "Errors.LEAD_OBTAIN_RULE": "当天此跟进人释放的线索不能当天申领",
    "MixedPotentialStatus_PopOver.7.POTENTIAL_STATUS_NORMAL-100": "客户已打款，财务审批流程中",
    "MixedPotentialStatus_PopOver.5.POTENTIAL_STATUS_NORMAL-60": "客户已经认同腾讯广告产品，就功能和价值进行分析和比较",
    "Errors.NO_LEAD": "未找到指定的线索",
    "Errors.NO_AGENCY_BM_ID": "无服务商或主体 ID",
    "LoginAccountValidPeriod.6.SIX_MONTHS": "六个月",
    "FeatureTag.11.FEATURE_202012_UNIBD_CENTER": "微信附近推（2020/12）",
    "CleaningStatus.2.CLEANING_STATUS_VALID": "清洗合格",
    "error.expected.date": "Date value expected",
    "Errors.MULTIPLE_EMPLOYEES": "QQ号({0})在{1}个服务商关联了账号，且不止一个有效，请联系用户管理员禁用已废弃账号",
    "LeadsTouchTag.0.LEADS_TOUCH_TAG_NEVER_CONTACT": "待联系",
    "AmsEmployeeGrade.1.EMPLOYEE_GRADE_LEADER": "负责人",
    "SystemSourceType.3.SYSTEM_SOURCE_TYPE_TENCENT_IMPORT_POTENTIAL": "沉默线索",
    "FusedOrderStatus.6.ORDER_STATUS_NOT_ONLINE": "开户驳回",
    "BuyingType.0.BUYINGTYPE_UNKOWN": "未知",
    "LeadReceiveRecordStatus.1.LEAD_RECEIVE_RECORD_SEND": "已发送",
    "ProgressStatus.0.PROGRESS_STATUS_UNKNOWN": "",
    "Errors.BAD_PROGRESS_STATUS": "线索{0}流程状态{1}非法",
    "error.number": "Numeric value expected",
    "Privilege.PERM_AGENCY_EMPLOYEE_MANAGE": "服务商 - 管理员工",
    "OriginalSourceType.SYSTEM_SOURCE_TYPE_UNKNOWN": "",
    "DistributeStatus.0.NOT_DISTRIBUTE": "未分发",
    "EmployeeSystemStatus.1.EMPLOYEE_SYSTEM_STATUS_NORMAL": "正常",
    "Privilege.PERM_AGENCY_REPORT_RECHARGE_REPORT_VIEW_ALL": "服务商 - 查看所有充值报表",
    "OutsideStatus.5.OUTSIDE_STATUS_DENIED": "已驳回",
    "SeatPreferredPhone.1.SEAT_PREFERRED_PHONE_MOBILE": "手机",
    "Forbidden.NoAgency": "禁止访问: 未找到相关的服务商信息（登录名称 {0}，QQ：{1}）",
    "FeatureTag.4.FEATURE_201909_ORBAC_SERVICE": "接入 OrBAC Service（2019/09）",
    "AdPlatformType.AD_PLATFORM_TYPE_MUTUAL_SELECTION": "互选广告",
    "Forbidden.NoAvailableAudience": "禁止访问: 免登录时未找到与 token 中 aud {0} 相关联的有效用户信息",
    "CleaningStatus.4.CLEANING_STATUS_TEMPNOTVALID": "暂不合格",
    "FeatureStatus.2.FEATURE_STATUS_WHITE": "全量上线",
    "RegistrationStatus.2.REGISTRATION_STATUS_UNREGISTERED": "待开户",
    "Privilege.PERM_AGENCY_ORDER_EDIT_SELF": "服务商 - 编辑自己的订单",
    "CustomerStatus.9.CUSTOMERSTATUS_DELETED": "删除",
    "FusedOrderStatus.1.ORDER_STATUS_SUBMITTED": "已提单",
    "ContractMethod.2.CONTRACT_METHOD_TELE_SALE": "电销",
    "CallEndType.2.CALL_END_TYPE_CUSTOMER_HANG_UP": "客户挂断",
    "constraint.min": "Minimum value: {0}",
    "Errors.EMPLOYEE_EXIST": "该QQ号已关联用户，请勿重复创建",
    "RegistrationStatus.0.REGISTRATION_STATUS_UNKNOWN": "",
    "ReviewRejectReason.2.REVIEW_REJECT_REASON_WRONG_INFO": "到款信息有误",
    "CallEndType.7.CALL_END_TYPE_ALERT_HANG_UP": "振铃挂断",
    "CustomerEmployeeRelationAddWay.2.WX_CUSTOMER_EMPLOYEE_ADD_WAY_SEARCH_PHONE": "搜索手机号",
    "Forbidden.InvalidAccountStatus": "禁止访问: 非法的账户状态 \"{0}\"",
    "Privilege.PERM_GLOBAL_AGENCY_LOGIN_AS": "全局 - 可以更换身份登录",
    "OrderStatus.7.ORDER_STATUS_REGISTRATION_UNASSIGNED": "待开户分配",
    "WechatAuthStatus.2.STATUS_CONFIRM_AUTHORIZATION": "已授权",
    "MaterialType.7.MATERIAL_SALE_ACTIVITY": "促销活动",
    "PotentialType_PopOver.17.POTENTIAL_SECOND_SEASON_CONTRACT_IN_PROGRESS": "合同推进中",
    "OutsideQueryType.3.OUTSIDE_QUERY_TYPE_ALL": "外勤查询",
    "CustomerEmployeeRelationAddWay.202.WX_CUSTOMER_EMPLOYEE_ADD_WAY_ADMIN_ASSIGN": "管理员/负责人分配",
    "OrderStatus.5.ORDER_STATUS_ONLINE": "已上线",
    "Privilege.PERM_AGENCY_POTENTIAL_ASSIGN_ANY_TO_ANY": "服务商 - 分配任何人的商机给任何人",
    "EmployeeSearchField.5.WECHAT": "微信号",
    "SystemSourceType.4.SYSTEM_SOURCE_TYPE_TENCENT_CRAWL_LEAD": "客户资源中心",
    "FeatureTag.3.FEATURE_201909_INTELLIGENT_CALL": "智能策略外显（2019/09）",
    "Privilege.PERM_ACCESS_CONTROL_VIEW": "服务商 - 访问控制查看",
    "DistributeStatus.1.ALREADY_DISTRIBUTE": "已分发",
    "OriginalSourceType.SYSTEM_SOURCE_TYPE_AGENCY_API_IMPORT": "自建",
    "DialInFirstTagType.5.DIAL_IN_FIRST_OTHER_TAG": "其他",
    "OrderStatus.3.ORDER_STATUS_UNPAID": "到款驳回",
    "CustomerStatus.7.CUSTOMERSTATUS_SUSPEND": "暂停",
    "CustomerStatus.10.CUSTOMERSTATUS_TEMPORARY_FROZEN": "冻结",
    "MaterialCreatorType.0.MATERIAL_CREATOR_UNKNOWN": "未知",
    "AdPlatformType.AD_PLATFORM_TYPE_MP": "微信",
    "Privilege.PERM_ORGANIZATION_TEAM_DELETE": "服务商 - 删除团队",
    "Unauthorized.InvalidToken": "鉴权失败: Token \"{0}\" 非法",
    "ContractMethod.4.CONTRACT_METHOD_NETWORK_SALE": "网销",
    "EmployeeSearchField.1.USER_ID": "用户 ID",
    "Privilege.PERM_AGENCY_EMPLOYEE_VIEW": "服务商 - 查看员工",
    "EmployeeSystemStatus.0.": "",
    "Unauthorized.NoValidAuthenticator": "鉴权失败：未找到有效的鉴权器",
    "Privilege.PERM_AGENCY_ORDER_ASSIGN_ANY_TO_ANY": "服务商 - 分配任何人的订单给任何人",
    "SystemSourceType.1.SYSTEM_SOURCE_TYPE_AGENCY_CREATED": "自建",
    "FeatureTag.2.FEATURE_201908_QUERY_LEADS_FOR_ALL_CONTACT_NUMBER": "外呼时查询所有电话号码相关的线索信息（2019/08）",
    "Privilege.PERM_AGENCY_ORDER_ASSIGN_SELF_TO_LEADER": "服务商 - 分配自己的订单给上级",
    "Privilege.PERM_AGENCY_LEAD_VIEW_SELF": "服务商 - 查看自己的线索",
    "OutsideVisitType.1.OUTSIDE_VISIT_INTERVIEW": "会面拜访",
    "CustomerGenderType.0.CUSTOMER_GENDER_UNKNOWN": "未知",
    "CustomerStatus.CUSTOMERSTATUS_TOBE_ACCEPTED": "待接受",
    "Forbidden.Unregistered": "禁止访问: 用户未注册（登录名称 {0}，QQ：{1}）",
    "DistributeStatus.2.DISTRIBUTING": "分发中",
    "AdPlatformType.AD_PLATFORM_TYPE_SOGOU": "搜狗",
    "CustomerStatus.CUSTOMERSTATUS_NORMAL": "有效",
    "TimeSpentSigningAContract.2.TIME_SPENT_SIGNING_A_CONTRACT_TWO_WEEKS": "两周",
    "Privilege.PERM_AGENCY_ORDER_VIEW_SELF": "服务商 - 查看自己的订单",
    "TimeSpentSigningAContract.0.TIME_SPENT_SIGNING_A_CONTRACT_UNKNOWN": "未知",
    "Errors.PROTECTION_RULE_DUPLICATE_COMPANY_NAME_AND_MOBILE.companyNameAndMobile": "公司名称且手机号码已存在，不可录入",
    "PotentialType_PopOver.16.POTENTIAL_SECOND_SEASON_PREPARE_ACCOUNT_OPENING_INFORMATION": "准备开户资料",
    "ContractMethod.1.CONTRACT_METHOD_INTERVIEW": "面访",
    "Errors.FORBID_DIAL_OUT": "禁止呼出",
    "Forbidden.MismatchedUserAgent": "禁止访问: 提供的两个 UserAgent \"{0}\" 与 \"{1}\" 不匹配",
    "Forbidden.InvalidEmployee": "禁止访问: 用户已禁用，用户 Id {2}（登录名称 {0}，QQ：{1}）",
    "MixedPotentialStatus.5.POTENTIAL_STATUS_NORMAL-60": "60（方案推荐中）",
    "OrderStatus_PopOver.6.ORDER_STATUS_NOT_ONLINE": "上线驳回",
    "Errors.REQUIRE_JSON": "请求必须为 JSON 格式。",
    "Errors.NO_COMPANY_ID": "公司 ID 缺失，尚未创建代理商对应的公司",
    "Privilege.PERM_AGENCY_LEAD_ASSIGN_GROUP_TO_GROUP": "服务商 - 分配自己/下属的线索给自己/下属",
    "Errors.EXCEED_OBTAIN_LIMIT": "商机和未到款订单数量超上限:{0}",
    "error.expected.jsobject": "Object value expected",
    "CleaningStatus.5.CLEANING_STATUS_CONTINUABLE": "继续跟进",
    "Privilege.PERM_AGENCY_POTENTIAL_ASSIGN_SELF_TO_LEADER": "服务商 - 分配自己的商机给上级",
    "LeadReceiveRecordType.2.LEAD_RECEIVE_RECORD_GROUP_MSG": "群发",
    "RegistrationAdPlatformType.2.AD_PLATFORM_TYPE_MP": "微信广告",
    "OutsideVisitType.5.OUTSIDE_VISIT_MARKETING": "会销",
    "Errors.NOT_LOGIN": "未找到当前已登录的用户。",
    "OutsideStatus.8.OUTSIDE_STATUS_VISITED": "已结束",
    "OperationMode.2.OPERATION_MODE_SELF_OPERATING": "自运营",
    "OutsideQueryType.2.OUTSIDE_QUERY_TYPE_FOR_MY_APPROVAL": "待我处理",
    "EmployeeSearchField.2.QQ_NUMBER": "QQ",
    "PotentialType_PopOver.13.POTENTIAL_SECOND_SEASON_COMMUNICATION_DELIVERY_PLAN": "沟通投放方案",
    "ReleaseType.9.ACTION_TYPE_MANUAL_RELEASE": "手动释放",
    "MaterialCreatorType.2.MATERIAL_CREATOR_CORP": "公司素材",
    "MixedPotentialStatus.4.POTENTIAL_STATUS_NORMAL-40": "40（需求明确）",
    "OperationMode.1.OPERATION_MODE_AGENCY_OPERATING": "代运营",
    "FusedOrderStatus.5.ORDER_STATUS_ONLINE": "已开户",
    "Education.2.MASTER": "硕士",
    "LeadsTouchTag.2.LEADS_TOUCH_TAG_NO_RESPONSE": "未回应",
    "ProtectionRule.5.PROTECTION_RULE_DUPLICATE_COMPANY_NAME_OR_MOBILE_OR_TELEPHONE": "公司名称或者任一手机号码或者任一座机号码相同，不允许录入",
    "Unauthorized.CheckTokenFailed": "鉴权失败: Token \"{0}\" 检测失败 - {1}",
    "Errors.NO_PERMISSION": "无访问权限:{0}",
    "error.real": "Real number value expected",
    "error.min": "Must be greater or equal to {0}",
    "CustomerStatus.4.CUSTOMERSTATUS_FROZEN": "封停",
    "BuyingType.1.BUYINGTYPE_AUCTION": "竞价账户",
    "FusedOrderStatus.4.ORDER_STATUS_REVIEW": "待开户",
    "Errors.CONTACT_NO_MOBILE_OR_TELEPHONE": "联系人手机或座机至少填一个",
    "SystemSourceType.2.SYSTEM_SOURCE_TYPE_TENCENT_IMPORT_LEAD": "新线索",
    "Privilege.PERM_AGENCY_LEAD_VIEW_ALL_PENDING": "服务商 - 查看所有待清洗的线索",
    "Errors.PROTECTION_RULE_DUPLICATE_COMPANY_NAME_OR_MOBILE_OR_TELEPHONE.companyName": "公司名称已存在，不可录入",
    "SeatPreferredPhone.2.SEAT_PREFERRED_PHONE_TELEPHONE": "固话",
    "Errors.PROTECTION_RULE_DUPLICATE_COMPANY_NAME_OR_MOBILE_OR_TELEPHONE.mobile": "手机号码[{0}]已存在，不可录入",
    "Forbidden.BlockedRemoteAddress": "禁止访问: 来源地址 \"{0}\" 已屏蔽",
    "LeadSourceType.2.LEAD_SOURCE_TENCENT": "腾讯导入",
    "CustomerEmployeeTagType.2.WX_CUSTOMER_EMPLOYEE_TAG_DIY": "个人自定义标签",
    "Privilege.PERM_AGENCY_ORDER_EDIT_ALL": "服务商 - 编辑所有订单",
    "FeatureTag.0.FEATURE_UNKNOWN": "",
    "PotentialType_PopOver.11.POTENTIAL_SECOND_SEASON_EXPLORING_CUSTOMER_NEEDS": "客户需求探寻中",
    "CallEndType.0.CALL_END_TYPE_UNKNOWN": "",
    "error.required": "This field is required",
    "LeadsTouchTag.3.LEADS_TOUCH_TAG_RESPONSED": "已回应",
    "MaterialContentType.1.MATERIAL_CONTENT_IMAGE": "图片",
    "Forbidden.NoPermission": "禁止访问: 无以下权限的许可 {0}",
    "FeatureTag.10.FEATURE_202008_WEB_FUSION": "Web界面融合（2020/08）",
    "LeadReceiveRecordType.0.LEAD_RECEIVE_RECORD_UNKNOWN": "未知",
    "LeadLayerType.0.LEAD_LAYER_SMB": "SMB",
    "Errors.NOT_SUPPORTED_UPLOAD_FILE": "不支持的文件格式，请上传EXCEL文件",
    "FusedOrderStatus.9.ORDER_STATUS_REGISTRATION_CLOSED": "开户关闭",
    "AdPlatformType.AD_PLATFORM_TYPE_LOCAL": "本地推",
    "Errors.NO_ACTION_RECORD": "未找到指定的操作记录",
    "Errors.NO_PRIVILEGED_CUSTOMER_MP": "未找到指定客户或无对客户的访问权限（MP 用户名称：{0}）",
    "Privilege.PERM_AGENCY_POTENTIAL_VIEW_ALL": "服务商 - 查看所有商机",
    "TimeSpentSigningAContract.3.TIME_SPENT_SIGNING_A_CONTRACT_THREE_WEEKS": "三周",
    "Errors.PROTECTION_RULE_DUPLICATE_COMPANY_NAME_OR_MOBILE.companyName": "公司名称已存在，不可录入",
    "ReleaseType.26.ACTION_TYPE_LEAD_AUTO_RELEASE": "自动释放",
    "Errors.CONTACT_MOBILE_FORMAT_ERROR": "联系人手机格式有误：{0}",
    "error.maxLength": "Maximum length is {0}",
    "FeatureTag.6.FEATURE_201909_WORKBENCH": "销售工作台（2019/09）",
    "MaterialContentType.0.MATERIAL_CONTENT_UNKNOWN": "未知",
    "OutsideStatus.7.OUTSIDE_STATUS_CLOSED": "已关闭",
    "FusedOrderStatus.2.ORDER_STATUS_PAID": "已到款",
    "Errors.NO_CALL_CENTER": "未找到指定的呼叫中心",
    "error.invalid.java.util.Date": "Invalid date value",
    "Privilege.PERM_AGENCY_LEAD_EDIT_GROUP": "服务商 - 编辑下属的线索",
    "PotentialType_PopOver.5.POTENTIAL_SECOND_SEASON_WECHAT_TO_BE_PASSED": "加微待通过",
    "LoginAccountValidPeriod.2.ONE_WEEK": "一周",
    "DialInFirstTagType.1.DIAL_IN_FIRST_DIRECT_CUSTOMER": "直销客户",
    "constraint.max": "Maximum value: {0}",
    "CallEndType.6.CALL_END_TYPE_QUEUE_HANG_UP": "排队挂断",
    "format.real": "Real",
    "formats.date": "yyyy-MM-dd",
    "RegistrationType.2.REGISTRATION_EXISTED": "已有账户",
    "Errors.ADVERTISER_INVALID_STATUS": "广告主当前状态不可用（{0}）",
    "PotentialType_PopOver.4.POTENTIAL_SECOND_SEASON_INSUFFICIENT_BUDGET": "预算不足",
    "Errors.CONTACT_EMAIL_FORMAT_ERROR": "邮箱格式错误",
    "AdPlatformType.AD_PLATFORM_TYPE_NEIGHBORHOOD": "附近推",
    "Errors.BAD_CUSTOMIZED_FIELD": "自定义字段名错误:{0}",
    "error.invalid": "Invalid value",
    "Privilege.PERM_AGENCY_ORDER_ONLINE_REVIEW": "服务商 - 订单上线审核",
    "Errors.GRAY_RELEASED_WITH_NO_AGNECY": "至少选择一家服务商!",
    "LeadLayerType.2.LEAD_LAYER_LA_UNRECOGNIZED": "未识别",
    "CustomerStatus.CUSTOMERSTATUS_SUSPEND": "暂停",
    "Privilege.PERM_AGENCY_POSITION_MANAGE": "服务商 - 管理岗位",
    "Errors.BAD_PARAM": "错误参数：{0}",
    "error.email": "Valid email required",
    "OriginalSourceType.SYSTEM_SOURCE_TYPE_TENCENT_IMPORT_LEAD": "腾讯导入",
    "FeatureTag.1.FEATURE_201908_MIGRATE_CALL_CENTER_TO_TCLOUD": "将呼叫中心迁移到腾讯云（2019/08）",
    "Privilege.PERM_AGENCY_POTENTIAL_EDIT_GROUP": "服务商 - 编辑下属的商机",
    "Privilege.PERM_ACCESS_CONTROL_LOGIN": "服务商 - 访问控制登录",
    "CustomerStatus.CUSTOMERSTATUS_TOBE_ACTIVATED": "待激活",
    "OrderStatus.4.ORDER_STATUS_REVIEW": "待上线审核",
    "Errors.PROTECTION_RULE_DUPLICATE_COMPANY_NAME_OR_MOBILE.mobile": "手机号码[{0}]已存在，不可录入",
    "OutsideStatus.3.OUTSIDE_STATUS_UNACCEPTED": "待接受",
    "ProtectionRule.1.PROTECTION_RULE_DUPLICATE_CUSTOMERID": "账户ID相同，不允许录入",
    "Errors.PROTECTION_RULE_DUPLICATE_COMPANY_NAME.companyName": "公司名称已存在，不可录入",
    "Privilege.PERM_AGENCY_LEAD_ASSIGN_SELF_TO_LEADER": "服务商 - 分配自己的线索给上级",
    "CustomerStatus.CUSTOMERSTATUS_MATERIAL_PREPARED": "广告主资料准备",
    "error.uuid": "Valid UUID required",
    "Privilege.PERM_AGENCY_POTENTIAL_CONVERT_SELF": "服务商 - 将自己的商机转为订单（即提单）",
    "Forbidden.RejectedAccountId": "禁止访问: 不能以 AccountId {0,number,#} 的身份访问",
    "Forbidden.UserUnemployed": "禁止访问: 用户已离职或未入职（登录名称 {0}，QQ：{1}）",
    "FusedOrderStatus.3.ORDER_STATUS_UNPAID": "到款驳回",
    "PotentialType_PopOver.15.POTENTIAL_SECOND_SEASON_RESOLVE_CUSTOMER_DOUBTS": "解决客户疑义",
    "ComplianceRule.1.COMPLIANCE_RULE_TYPE_CONNECT_TIMES_VALIDATE_CALL_TIMES": "通次",
    "MixedPotentialStatus.3.POTENTIAL_STATUS_NORMAL-20": "20（初步建联）",
    "CustomerEmployeeTagType.0.WX_CUSTOMER_EMPLOYEE_TAG_UNKNOWN": "未知",
    "Errors.NO_POTENTIAL": "未找到指定的商机",
    "Privilege.PERM_AGENCY_POTENTIAL_VIEW_GROUP": "服务商 - 查看下属的商机",
    "SeatPreferredPhone.4.SEAT_PREFERRED_PHONE_SIP_DEVICE": "SIP分机",
    "RegistrationStatus.4.REGISTRATION_STATUS_REGISTRATION_SUBMITTED": "已提交开户",
    "OriginalSourceType.SYSTEM_SOURCE_TYPE_TENCENT_CRAWL_MARKETING": "腾讯导入",
    "OrderStatus.1.ORDER_STATUS_SUBMITTED": "已提单",
    "Privilege.PERM_AGENCY_POTENTIAL_RELEASE_GROUP": "服务商 - 释放下属的商机到公海",
    "CallEndType.3.CALL_END_TYPE_TURN_TO_IVR": "回转IVR",
    "Privilege.PERM_AGENCY_POTENTIAL_ASSIGN_SELF_TO_ANY": "服务商 - 分配自己的商机给任何人",
    "Privilege.PERM_AGENCY_POTENTIAL_EDIT_SELF": "服务商 - 编辑自己的商机",
    "LoginAccountValidPeriod.3.ONE_MONTH": "一个月",
    "MixedPotentialStatus_PopOver.6.POTENTIAL_STATUS_NORMAL-80": "客户表现出明确的合作意愿，但尚需处理合作细节",
    "OutsideStatus.1.OUTSIDE_STATUS_IS_UNREVIEW": "外勤待审核",
    "EmployeeSearchField.3.USER_NAME": "名称",
    "LoginAccountValidPeriod.5.THREE_MONTHS": "三个月",
    "Privilege.PERM_AGENCY_LEAD_EDIT_SELF": "服务商 - 编辑自己的线索",
    "CustomerStatus.CUSTOMERSTATUS_UNREGISTERED": "未注册",
    "CustomerStatus.CUSTOMERSTATUS_DELETED": "删除",
    "error.expected.jsstring": "String value expected",
    "Unauthorized.MissingJwtClaim": "鉴权失败: 缺少 JWT 声明 - {0}",
    "Forbidden.NoEmployee": "禁止访问: 未找到相关的员工信息（登录名称 {0}，QQ：{1}）",
    "CustomerEmployeeRelationAddWay.0.WX_CUSTOMER_EMPLOYEE_ADD_WAY_UNKNOWN": "未知来源",
    "MaterialType.0.MATERIAL_UNKNOWN": "未知",
    "PotentialType_PopOver.10.POTENTIAL_SECOND_SEASON_CONSULTING_PRODUCT_CASE": "咨询产品案例",
    "Errors.NO_REOBTAIN_DAYS_AFTER_RELEASE": "{0}天内不可重复认领",
    "OriginalSourceType.SYSTEM_SOURCE_TYPE_TENCENT_IMPORT_POTENTIAL": "腾讯导入",
    "RegistrationStatus.5.REGISTRATION_STATUS_DENIED": "已拒绝",
    "Errors.EMPLOYEE_NOT_EXIST": "不存在的用户",
    "WechatAuthStatus.0.": "",
    "LeadLayerType.1.LEAD_LAYER_LA": "LA",
    "OrderStatus_PopOver.1.ORDER_STATUS_SUBMITTED": "已提单",
    "error.max": "Must be less or equal to {0}",
    "format.numeric": "Numeric",
    "error.expected.uuid": "UUID value expected",
    "MaterialContentType.3.MATERIAL_CONTENT_FILE": "普通文件",
    "PotentialType_PopOver.7.POTENTIAL_SECOND_SEASON_QUALIFICATION_TO_BE_CULTIVATED": "资质符合待培育",
    "Education.0.UNKNOWN": "未知",
    "Errors.UPLOAD_FILE_TIMEOUT": "EXCEL文件处理超时",
    "format.date": "Date ('{0}')",
    "Privilege.PERM_AGENCY_POSITION_VIEW": "服务商 - 查看岗位",
    "error.expected.validenumvalue": "Valid enumeration value expected",
    "TimeSpentSigningAContract.1.TIME_SPENT_SIGNING_A_CONTRACT_ONE_WEEK": "一周",
    "DialInFirstTagType.4.DIAL_IN_FIRST_EXIST_AGENCY": "现有服务商",
    "SeatPreferredPhone.3.SEAT_PREFERRED_PHONE_SIP": "SIP分机",
    "Education.8.OTHER": "其他",
    "CallEndType.4.CALL_END_TYPE_ALL_TAKE_APART": "全拆",
    "Privilege.PERM_AGENCY_POTENTIAL_ASSIGN_GROUP_TO_GROUP": "服务商 - 分配自己/下属的商机给自己/下属",
    "OrderStatus.2.ORDER_STATUS_PAID": "已到款",
    "PotentialType_PopOver.2.POTENTIAL_SECOND_SEASON_INDUSTRY_NON_ACCESS": "行业不准入",
    "Forbidden.InvalidAgency": "禁止访问: 服务商已禁用，服务商 Id {2}（登录名称 {0}，QQ：{1}）",
    "Privilege.PERM_AGENCY_ORDER_VIEW_GROUP": "服务商 - 查看下属的订单",
    "CustomerStatus.8.CUSTOMERSTATUS_MATERIAL_PREPARED": "广告主资料准备",
    "Forbidden.UserExpired": "禁止访问: 用户已过期，过期时间 {2}（登录名称 {0}，QQ：{1}）",
    "VisibilityScope.2.VISIBILITY_SCOPE_PUBLIC": "公海",
    "ReviewRejectReason.1.REVIEW_REJECT_REASON_NO_PAYMENT": "未到款",
    "OutsideQueryType.0.OUTSIDE_QUERY_TYPE_UNKNOWN": "",
    "error.path.empty": "Empty path",
    "Privilege.PERM_GLOBAL_AGENCY_MANAGE": "全局 - 管理服务商",
    "CleaningStatus.1.CLEANING_STATUS_PENDING": "待清洗",
    "constraint.pattern": "Required pattern: {0}",
    "PotentialType_PopOver.20.POTENTIAL_SECOND_SEASON_ALREADY_PAID": "已打款",
    "error.expected.time": "Time value expected",
    "error.expected.enumstring": "String value expected",
    "OrderStatus_PopOver.3.ORDER_STATUS_UNPAID": "到款驳回",
    "BuyingType.2.BUYINGTYPE_CONTRACT": "合约账户",
    "PotentialType_PopOver.12.POTENTIAL_SECOND_SEASON_ALREADY_APPOINTMENT_INTERVIEW": "已约面访",
    "FeatureTag.16.FEATURE_202108_POTENTIAL_HIGHSEA_AUTOCONFIGURATION": "商机公海拨打电话规则（2021/08）",
    "VisibilityScope.3.VISIBILITY_SCOPE_DISTRIBUTE_POOL": "分发池",
    "Privilege.PERM_ORGANIZATION_TEAM_ADD": "服务商 - 新增团队",
    "Unauthorized.CheckJwtTokenFailed": "鉴权失败: 校验 JWT Token 失败",
    "MaterialType.4.MATERIAL_FINANCE_FLOW": "财务流程",
    "CustomerEmployeeRelationAddWay.5.WX_CUSTOMER_EMPLOYEE_ADD_WAY_PHONE_BOOK": "手机通讯录",
    "ComplianceRule.2.COMPLIANCE_RULE_TYPE_TOTAL_DIAL_OUT_SECONDS": "通时",
    "RegistrationType.1.REGISTRATION_NEW": "新开户",
    "DialInFirstTagType.8.DIAL_IN_FIRST_NEW_LEAD": "新线索",
    "FeatureTag.13.FEATURE_202107_QIDIAN_ROLES": "坐席角色（2021/07）",
    "PotentialType_PopOver.0.POTENTIAL_SECOND_SEASON_UNKNOWN": "未知",
    "Privilege.PERM_ACCESS_CONTROL_PERMISSION_MANAGE": "全局 - 权限管理",
    "error.path.missing": "Missing path",
    "CustomerEmployeeStatus.1.WX_CUSTOMER_EMPLOYEE_DELETED": "已删除",
    "OutsideResultType.0.OUTSIDE_RESULT_TYPE_UNKNOWN": "",
    "Privilege.PERM_AGENCY_POTENTIAL_OBTAIN_TO_SELF": "服务商 - 从公海中申领商机给自己",
    "CustomerEmployeeRelationAddWay.7.WX_CUSTOMER_EMPLOYEE_ADD_WAY_WX_FRIEND_APPLICATION": "来自微信的添加好友申请",
    "Errors.NUM_ALREADY_EXIST_IN_GRAY_LIST": "该号码已经被添加进黑名单",
    "OriginalSourceType.SYSTEM_SOURCE_TYPE_AGENCY_CREATED": "自建"
  };
  return f
})();
window.pageProps = {
  "basename": "/ams",
  "sentry": {"dsn": "https://20b931ae5e5f41d28042b3521a3cfa1a@report.url.cn/sentry/1584", "environment": "prod"},
  "orbacUrl": "http://orbac.tsa.oa.com/",
  "agencyFusionRegistrationAssignIframeUrl": "//agent.e.qq.com/portal/embedded/assign",
  "agencyFusionRegistrationRegisterIframeUrl": "//agent.e.qq.com/portal/embedded/register",
  "callCenter": [{
    "vendor": "CALL_CENTER_VENDOR_CHANNELSOFT",
    "entryJs": "https://open2.ccod.com/WAEX/WA.js",
    "isCallTelWithExt": false
  }, {
    "vendor": "CALL_CENTER_VENDOR_QIDIAN",
    "entryJs": "https://bqq.gtimg.com/ccsdk/v2/qd-agentbar-webrtc.js",
    "isCallTelWithExt": false
  },
 {
     "vendor": "CALL_CENTER_VENDOR_TCCC",
      "entryJs": "",
     "isCallTelWithExt": false
  },
]
};

if (isOa()) {
  window.pageProps = {
    "basename": "/ams",
    "sentry": {"dsn": "https://20b931ae5e5f41d28042b3521a3cfa1a@report.url.cn/sentry/1584", "environment": "prerelease"},
    "envName": "预发布环境",
    "orbacUrl": "http://orbac.tsa.oa.com/",
    "agencyFusionRegistrationAssignIframeUrl": "//agent-prerelease.e.qq.com/portal/embedded/assign",
    "agencyFusionRegistrationRegisterIframeUrl": "//agent-prerelease.e.qq.com/portal/embedded/register",
    "callCenter": [{
      "vendor": "CALL_CENTER_VENDOR_CHANNELSOFT",
      "entryJs": "https://open2.ccod.com/WAEX/WA.js",
      "isCallTelWithExt": false
    }, {
      "vendor": "CALL_CENTER_VENDOR_QIDIAN",
      "entryJs": "https://bqq.gtimg.com/ccsdk/v2/qd-agentbar-webrtc.js",
      "isCallTelWithExt": false
    }, 
    // {
    //    "vendor": "CALL_CENTER_VENDOR_TCCC",
    //     "entryJs": "",
    //   "isCallTelWithExt": false
    // },
  ]
  }
}

window.jsRoutes = jsRoutes;
